<template>
  <div class="zeugnisgenerator" v-if="categories && savedEntry && users">
    <!-- Steps -->
    <div class="steps">
      <div class="flex flex-col items-center gap-6">
        <div class="relative" v-for="(stepEntry, sIndex) in steps">

          <button 
            @click="switchStep(sIndex)"
            class="step"
            :class="[step == sIndex ? 'current-step' : '', sIndex < textToStep[savedEntry.aktuellerSchritt] || textToStep[savedEntry.aktuellerSchritt] == 6 ? 'completed-step' : '', sIndex == textToStep[savedEntry.aktuellerSchritt] ? 'aktueller-step' : '']"
            :disabled="checkDisabled(sIndex) || savedEntry.andererAbschlussgrund == ''"
            tabindex="-1"
          >
            <div class="step-check">
              <i class="fa-solid fa-check"></i>
            </div>
            <div class="step-circle">
              {{ sIndex + 1 }}
            </div>
            <div class="step-text">
              {{ stepEntry }}
            </div>
            <div class="gear-border">
            </div>
          </button>
          <div class="absolute top-0 -right-12 grid grid-cols-1 gap-2" v-if="sIndex == 1 && step == 1">
            <template v-for="(category, cIndex) in categories">
              <button
                @click="switchCategory(cIndex)"
                class="category-step"
                :class="[activeCategoryIndex == cIndex ? 'step-active' : '', activeCategoryIndex > cIndex ? 'completed-step' : '']"
                tabindex="-1"
              >
                {{ cIndex + 1 }}
              </button>
            </template>
          </div>
        </div>
      </div>
      <a :href="SITEURL" class="flex items-center justify-center" tabindex="-1">
        <img :src="`${SITEURL}assets/logo-white.svg`" class="w-20">
      </a>
    </div>

    <!-- Seiteninhalt -->
    <div class="seiteninhalt" v-if="categories && savedEntry && users" @click="hideToolbar()">

      <template v-if="navTab == null">
        <div class="flex justify-between mb-16">
          <h1 class="text-f2 text-primary font-extrabold" v-if="categories.length > 0 || step == 0">
            {{ steps[step] }}
            <span class="font-light" v-if="step==1">{{ categories[activeCategoryIndex].title }}</span>
          </h1>

          <div class="flex items-center gap-2">
            <div class="border-primary border-solid border bg-white rounded-full w-10 h-10 flex items-center justify-center">
              <i class="fa-duotone fa-thin fa-user text-primary"></i>
            </div>
            <div class="text-f6 text-primary">{{ currentUser.email }}</div>
          </div>
        </div>

        <div class="" :class="{'disabled-container': checkDisabledCurrentPage(step)}">
          <div v-if="step == 0">
            <div class="grid grid-cols-2 s:grid-cols-1 gap-y-4 gap-x-6">
              
              <div class="grid grid-cols-1 gap-2">
                <label for="zeugnisart">Zeugnisart <span class="text-red-600">*</span></label>
                <select 
                  v-model="savedEntry.zeugnisart"
                  id="zeugnisart"
                  :disabled="checkDisabledCurrentPage(step)"
                  @change="changeEinleittext()"
                  @focus="scrollToField"
                >
                  <option value="zwischenzeugnis">Zwischenzeugnis</option>
                  <option value="arbeitszeugnis">Arbeitszeugnis</option>
                  <option value="arbeitsbestaetigung">Arbeitsbestätigung</option>
                  <option value="arbeitszeugnisLernende">Arbeitszeugnis Lernende</option>
                </select>
                <div v-if="errors['zeugnisart']" class="text-rot text-f5 font-medium">{{ errors['zeugnisart'] }}</div>
              </div>

              <div class="grid grid-cols-1 gap-2">
                <label for="hrVerantwortlicher">HR-Verantwortliche:r <span class="text-red-600">*</span></label>
                <Dropdown
                  :options="users"
                  :search="true"
                  :entry="savedEntry"
                  :entry-field="'hrVerantwortlicher'"
                  :disabled="checkDisabledCurrentPage(step)"
                  id="hrVerantwortlicher"
                  v-if="users && savedEntry && savedEntry.hrVerantwortlicher.length > 0"
                ></Dropdown>
                <div v-if="errors['hrVerantwortlicher']" class="text-rot text-f5 font-medium">{{ errors['hrVerantwortlicher'] }}</div>
              </div>

              <div class="grid grid-cols-1 gap-2">
                <label for="vorgesetzter">1. Vorgesetzte:r <span class="text-red-600">*</span></label>
                <Dropdown
                  :options="users"
                  :search="true"
                  :entry="savedEntry"
                  :entry-field="'vorgesetzter'"
                  :disabled="checkDisabledCurrentPage(step)"
                  id="vorgesetzter"
                  v-if="users && savedEntry"
                ></Dropdown>
                <div v-if="errors['vorgesetzter']" class="text-rot text-f5 font-medium">{{ errors['vorgesetzter'] }}</div>

              </div>

              <div class="grid grid-cols-1 gap-2">
                <label for="hoehererVorgesetzter">2. Vorgesetzte:r <span class="text-red-600">*</span></label>
                <Dropdown
                  :options="users"
                  :search="true"
                  :entry="savedEntry"
                  :entry-field="'hoehererVorgesetzter'"
                  :disabled="checkDisabledCurrentPage(step)"
                  id="hoehererVorgesetzter"
                  v-if="users && savedEntry"
                ></Dropdown>
                <div v-if="errors['hoehererVorgesetzter']" class="text-rot text-f5 font-medium">{{ errors['hoehererVorgesetzter'] }}</div>
              </div>

              <div class="grid grid-cols-1 gap-2">
                <label for="vorname">Vorname <span class="text-red-600">*</span></label>
                <input
                  type="text"
                  v-model="savedEntry.vorname"
                  id="vorname"
                  :disabled="checkDisabledCurrentPage(step)"
                  @focus="scrollToField"
                  @change="adjustValue()"
                  ></input>
                <div v-if="errors['vorname']" class="text-rot text-f5 font-medium">{{ errors['vorname'] }}</div>
              </div>

              <div class="grid grid-cols-1 gap-2">
                <label for="nachname">Nachname <span class="text-red-600">*</span></label>
                <input 
                  type="text"
                  v-model="savedEntry.nachname"
                  id="nachname"
                  :disabled="checkDisabledCurrentPage(step)"
                  @focus="scrollToField"
                  @change="adjustValue()"
                  ></input>
                <div v-if="errors['nachname']" class="text-rot text-f5 font-medium">{{ errors['nachname'] }}</div>
              </div>

              <div class="grid grid-cols-1 gap-2">
                <label for="geschlecht">Geschlecht <span class="text-red-600">*</span></label>
                <select v-model="savedEntry.geschlecht"
                  :disabled="checkDisabledCurrentPage(step)"
                  id="geschlecht"
                  @focus="scrollToField"
                  @change="adjustValue()"
                >
                  <option value="m">männlich</option>
                  <option value="w">weiblich</option>
                </select>
                <div v-if="errors['geschlecht']" class="text-rot text-f5 font-medium">{{ errors['geschlecht'] }}</div>
              </div>

              <div class="grid grid-cols-1 gap-2">
                <label for="geburtsdatum">Geburtsdatum <span class="text-red-600">*</span></label>
                <input 
                  type="date"
                  v-model="savedEntry.geburtsdatum"
                  id="geburtsdatum"
                  :disabled="checkDisabledCurrentPage(step)"
                  @focus="scrollToField"
                  @change="adjustValue()"
                  ></input>
                <div v-if="errors['geburtsdatum']" class="text-rot text-f5 font-medium">{{ errors['geburtsdatum'] }}</div>
              </div>

              <div class="grid grid-cols-1 gap-2">
                <label for="heimatort">Heimatort</label>
                <input 
                  type="text"
                  v-model="savedEntry.heimatort"
                  id="heimatort"
                  :disabled="checkDisabledCurrentPage(step)"
                  @focus="scrollToField"
                  @change="adjustValue()"
                ></input>
                <div v-if="errors['heimatort']" class="text-rot text-f5 font-medium">{{ errors['heimatort'] }}</div>
              </div>

              <div class="grid grid-cols-1 gap-2">
                <label for="pensum">Pensum <span class="text-red-600">*</span></label>
                <input 
                  type="number"
                  max="100"
                  min="0"
                  v-model="savedEntry.pensum"
                  id="pensum"
                  :disabled="checkDisabledCurrentPage(step)"
                  @focus="scrollToField"
                  @change="adjustValue()"
                ></input>
                <div v-if="errors['pensum']" class="text-rot text-f5 font-medium">{{ errors['pensum'] }}</div>
              </div>

              <div class="grid grid-cols-1 gap-2">
                <label for="anstellungSeit">Anstellung seit <span class="text-red-600">*</span></label>
                <input 
                  type="date"
                  v-model="savedEntry.anstellungSeit"
                  id="anstellungSeit"
                  :disabled="checkDisabledCurrentPage(step)"
                  @focus="scrollToField"
                  @change="adjustValue()"
                ></input>
                <div v-if="errors['anstellungSeit']" class="text-rot text-f5 font-medium">{{ errors['anstellungSeit'] }}</div>
              </div>


              <div class="grid grid-cols-1 gap-2" v-if="savedEntry.zeugnisart != 'zwischenzeugnis'">
                <label for="anstellungBis">Anstellung bis <span class="text-red-600">*</span></label>
                <input 
                  type="date"
                  v-model="savedEntry.anstellungBis"
                  id="anstellungBis"
                  :disabled="checkDisabledCurrentPage(step)"
                  @focus="scrollToField"
                  @change="adjustValue()"
                ></input>
                <div v-if="errors['anstellungBis']" class="text-rot text-f5 font-medium">{{ errors['anstellungBis'] }}</div>
              </div>

              <!-- <div class="grid grid-cols-1 gap-2">
                <label for="angepassterEinleittext">angepasster Einleittext (z.B. bei mehreren Funktionen)</label>
                <Einleittext
                  v-model="savedEntry.angepassterEinleittext"

                  :vorname="savedEntry.vorname"
                  :nachname="savedEntry.nachname"
                  :geburtsdatum="savedEntry.geburtsdatum ? formatDate(savedEntry.geburtsdatum) : ''"
                  :heimatort="savedEntry.heimatort"
                  :angestelltSeit="savedEntry.anstellungSeit  ? formatDate(savedEntry.anstellungSeit) : ''"
                  :angestelltBis="savedEntry.anstellungBis  ? formatDate(savedEntry.anstellungBis) : ''"
                  :funktion="savedEntry.funktion.length > 0 ? savedEntry.funktion[0].title : ''"
                  :abteilung="savedEntry.abteilung.length > 0 ? savedEntry.abteilung[0].title : ''"
                  :bereich="savedEntry.bereich.length > 0 ? savedEntry.bereich[0].title : ''"
                  :teamText="savedEntry.team.length > 0 ? savedEntry.team[0].vorlageText : ''"
                  :team="savedEntry.team.length > 0 ? savedEntry.team[0].title : ''"
                  :geschlecht="savedEntry.geschlecht"
                  :pensum="savedEntry.pensum"


                  id="angepassterEinleittext"
                  :disabled="checkDisabledCurrentPage(step)"
                ></Einleittext>
                <div v-if="errors['angepassterEinleittext']" class="text-rot text-f5 font-medium">{{ errors['angepassterEinleittext'] }}</div>
              </div> -->

              <div class="grid grid-cols-1 gap-2">
                <label for="abschlussgrund">Abschlussgrund <span class="text-red-600">*</span></label>
                <FunktionenDropdown
                  :options="abschlussgründe"
                  :search="true"
                  :entry="savedEntry"
                  :entry-field="'abschlussgrund'"
                  :disabled="checkDisabledCurrentPage(step)"
                  placeholder="Abschlussgrund auswählen"
                  id="abschlussgrund"
                  v-if="abschlussgründe && savedEntry"
                ></FunktionenDropdown>
                <div v-if="errors['abschlussgrund']" class="text-rot text-f5 font-medium">{{ errors['abschlussgrund'] }}</div>
              </div>

              <div class="flex flex-col gap-2 row-span-2" v-if="savedEntry.abschlussgrund.length > 0 && savedEntry.abschlussgrund[0].title == 'Anderer Abschlussgrund'">
                <label for="andererAbschlussgrund" class="grow-0">anderer Abschlusstext  <span class="text-red-600">*</span></label>
                <textarea
                  v-model="savedEntry.andererAbschlussgrund"
                  id="andererAbschlussgrund"
                  :disabled="checkDisabledCurrentPage(step)"
                  class="shrink-0 grow"
                  @focus="scrollToField"
                ></textarea>
                <div v-if="errors['andererAbschlussgrund']" class="text-rot text-f5 font-medium">{{ errors['andererAbschlussgrund'] }}</div>
              </div>

              <div class="grid grid-cols-1 gap-2">
                <label for="funktion">Funktion <span class="text-red-600">*</span></label>
                <FunktionenDropdown
                  :options="funktionen"
                  :search="true"
                  :entry="savedEntry"
                  :entry-field="'funktion'"
                  :disabled="checkDisabledCurrentPage(step)"
                  id="funktion"
                  @change="changeEinleittext()"
                  v-if="funktionen && savedEntry"
                ></FunktionenDropdown>
                <div v-if="errors['funktion']" class="text-rot text-f5 font-medium">{{ errors['funktion'] }}</div>
              </div>

              <div class="grid grid-cols-1 gap-2">
                <label for="bereich">Bereich <span class="text-red-600">*</span></label>
                <FunktionenDropdown
                  :options="bereiche"
                  :search="true"
                  :entry="savedEntry"
                  :entry-field="'bereich'"
                  :disabled="checkDisabledCurrentPage(step)"
                  placeholder="Bereich auswählen"
                  id="bereich"
                  v-if="funktionen && savedEntry"
                ></FunktionenDropdown>
                <div v-if="errors['bereich']" class="text-rot text-f5 font-medium">{{ errors['bereich'] }}</div>
              </div>

              <div class="grid grid-cols-1 gap-2" v-if="savedEntry.bereich.length > 0 && savedEntry.bereich[0].children.length > 0">
                <label for="abteilung">Abteilung <span class="text-red-600">*</span></label>
                <FunktionenDropdown
                  :options="savedEntry.bereich[0].children"
                  :search="true"
                  :entry="savedEntry"
                  :entry-field="'abteilung'"
                  :disabled="checkDisabledCurrentPage(step)"
                  placeholder="Abteilung auswählen"
                  id="abteilung"
                  v-if="funktionen && savedEntry"
                ></FunktionenDropdown>
                <div v-if="errors['abteilung']" class="text-rot text-f5 font-medium">{{ errors['abteilung'] }}</div>
              </div>

              <div class="grid grid-cols-1 gap-2" v-if="savedEntry.abteilung.length > 0 && savedEntry.abteilung[0].children.length > 0">
                <label for="team">Team <span class="text-red-600">*</span></label>
                <FunktionenDropdown
                  :options="savedEntry.abteilung[0].children"
                  :search="true"
                  :entry="savedEntry"
                  :entry-field="'team'"
                  :disabled="checkDisabledCurrentPage(step)"
                  placeholder="Team auswählen"
                  id="team"
                  v-if="funktionen && savedEntry"
                ></FunktionenDropdown>
                <div v-if="errors['team']" class="text-rot text-f5 font-medium">{{ errors['team'] }}</div>
              </div>
            </div>

          </div>

          <div v-if="step == 1">
            <div v-if="categories.length == 0">
              Die für das Zeugnis gewählte Funktion hat keine zugewiesenen Beurteilungsvorlagen.
            </div>

            <template v-for="(category, cIndex) in categories">
              <div v-if="activeCategoryIndex == cIndex" class="grid grid-cols-2 m:grid-cols-1 gap-x-8 gap-y-6">
                <div v-for="(vorlage, vIndex) in category.vorlagen" :key="vIndex">
                  <div class="relative">
                    <h2 class="text-f3 font-extrabold">{{vorlage.title}}</h2>
                    <div class="w-full grid grid-cols-1">
                      <div class="flex justify-between">
                        <div class="relative flex flex-col items-start pb-2">
                          <label>Bewertung</label>
                          <div>
                            <star-rating v-model="vorlage.rating"  :value="vorlage.rating" :vorlage="vorlage" @ratingData="updateText" />
                          </div>
                        </div>

                        <div class="flex items-center gap-2">
                          <div class="flex items-center gap-4 text-f5">
                            <template 
                              v-if="vorlage.aiGenerationMode == 'ki' && vorlage.aiTexts.length > 0"
                            >
                              <div class="text-primary">
                                <button
                                  @click="previousAIText(vorlage)"
                                  :disabled="vorlage.currentAiTextIndex == 0"
                                  class="btn-no-bg p-0 text-primary"
                                >
                                  <i class="fa-solid fa-chevron-left"></i>
                                </button>
                                {{ vorlage.currentAiTextIndex + 1 }} | {{ vorlage.aiTexts.length }}
                                <button
                                  @click="nextAIText(vorlage)"
                                  :disabled="vorlage.currentAiTextIndex == vorlage.aiTexts.length - 1"
                                  class="btn-no-bg p-0 text-primary"
                                >
                                  <i class="fa-solid fa-chevron-right"></i>
                                </button>
                              </div>
                              <button
                                @click="regenerateAIText(vorlage)"
                                class="btn-no-bg py-0 text-primary-600 text-f3"
                              >
                                <i class="fa-duotone fa-thin fa-repeat"></i>
                              </button>
                            </template>
                            <div 
                              class="flex items-center gap-4"
                              :title="vorlage.rating == 0 ? 'Du musst das Kriterium bewerten, bevor die KI es umschreiben kann.' : ''"
                              :class="vorlage.rating == 0 ? 'cursor-not-allowed' : ''"
                            >
                              <button
                                @click="setAIGenerationMode('template', vorlage)"
                                class="btn-no-bg p-0"
                                :class="vorlage.aiGenerationMode == 'template' ? 'text-primary' : ''"
                                :disabled="vorlage.rating == 0 || !vorlage.aiOn"
                              >
                              <span class="underline">T</span>emplate
                              </button>
                              
                              <button
                                @click="setAIGenerationMode('rechtschreibpruefung', vorlage)"
                                class="btn-no-bg p-0"
                                :class="vorlage.aiGenerationMode == 'rechtschreibpruefung' ? 'text-primary' : ''"
                                :disabled="vorlage.rating == 0 || !vorlage.aiOn"
                              >
                                <span class="underline">R</span>echtschreibprüfung
                              </button>
                              
                              <button
                                @click="setAIGenerationMode('ki', vorlage)"
                                class="btn-no-bg p-0"
                                :class="vorlage.aiGenerationMode == 'ki' ? 'text-primary' : ''"
                                :disabled="vorlage.rating == 0 || !vorlage.aiOn"
                              >
                                <span class="underline">K</span>I
                              </button>
                            </div>

                            <div class="flex items-center">
                              <input type="checkbox"
                                v-model="vorlage.aiOn"
                                class="checkbox"
                                :id="'toggleVorlage' + String(cIndex) + String(vIndex)"
                                :disabled="vorlage.rating == 0"
                                @change="switchVorlageKiMode(vorlage)"
                              ></input>
                              <label :for="'toggleVorlage' + String(cIndex) + String(vIndex)" class="switch">
                                <div class="circle">
                                  <i class="fa-duotone fa-thin fa-robot"></i>
                                </div>
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="grow grid grid-cols-1 items-end">
                        <vorlage-text 
                          v-model="vorlage.text"
                          :vorlage="vorlage"
                          :vorname="savedEntry.vorname"
                          :nachname="savedEntry.nachname"
                          :geburtsdatum="savedEntry.geburtsdatum ? formatDate(savedEntry.geburtsdatum) : ''"
                          :heimatort="savedEntry.heimatort"
                          :angestelltSeit="savedEntry.anstellungSeit  ? formatDate(savedEntry.anstellungSeit) : ''"
                          :angestelltBis="savedEntry.anstellungBis  ? formatDate(savedEntry.anstellungBis) : ''"
                          :funktion="savedEntry.funktion.length > 0 ? (savedEntry.funktion[0].funktionBezeichnungText ?? savedEntry.funktion[0].title) : ''"
                          :abteilung="savedEntry.abteilung.length > 0 ? savedEntry.abteilung[0].title : ''"
                          :bereich="savedEntry.bereich.length > 0 ? savedEntry.bereich[0].title : ''"
                          :teamText="savedEntry.team.length > 0 ? savedEntry.team[0].vorlageText : ''"
                          :team="savedEntry.team.length > 0 ? savedEntry.team[0].title : ''"
                          :geschlecht="savedEntry.geschlecht"
                          :pensum="savedEntry.pensum"
                          :disabled="checkDisabledCurrentPage(step) || vorlage.rating == 0"

                          @ratingData="updateText" @changeMode="changeVorlageKiMode"
                        />
                      </div>
                    </div>
                    <div v-if="vorlage.loading" class="absolute top-0 left-0 w-full h-full bg-white bg-opacity-50 flex items-center justify-center">
                      <i class="fa-solid fa-spinner fa-spin"></i>
                    </div>
                  </div>
                </div>

                <div class="col-span-2" v-if="category.title == 'Abschlusstext'">
                  <!-- <h2>{{ savedEntry.abschlussgrund[0].title }}</h2> -->
                  <div class="">
                    <div class="flex items-center gap-4 mb-4" v-if="savedEntry.abschlussgrund[0].title != 'Anderer Abschlussgrund'">
                      Neutraler Abschlusstext
                      <input
                        type="checkbox"
                        v-model="positiverAbschlusstext"
                        class="checkbox"
                        id="positiverAbschlusstext"
                        :disabled="checkDisabledCurrentPage(step)"
                        @change="changeAbschlusstext()"
                      ></input>
                      <label for="positiverAbschlusstext" class="switch">
                        <div class="circle">
                        </div>
                      </label>
                      Positiver Abschlusstext
                    </div>

                    <div class="grid grid-cols-1 gap-2">
                      <label for="andererAbschlussgrund" class="grow-0">Abschlusstext  <span class="text-red-600">*</span></label>
                      <Abschlusstext
                        v-model="savedEntry.andererAbschlussgrund"

                        :vorname="savedEntry.vorname"
                        :nachname="savedEntry.nachname"
                        :geburtsdatum="savedEntry.geburtsdatum ? formatDate(savedEntry.geburtsdatum) : ''"
                        :heimatort="savedEntry.heimatort"
                        :angestelltSeit="savedEntry.anstellungSeit  ? formatDate(savedEntry.anstellungSeit) : ''"
                        :angestelltBis="savedEntry.anstellungBis  ? formatDate(savedEntry.anstellungBis) : ''"
                        :funktion="savedEntry.funktion.length > 0 ? savedEntry.funktion[0].title : ''"
                        :abteilung="savedEntry.abteilung.length > 0 ? savedEntry.abteilung[0].title : ''"
                        :bereich="savedEntry.bereich.length > 0 ? savedEntry.bereich[0].title : ''"
                        :teamText="savedEntry.team.length > 0 ? savedEntry.team[0].vorlageText : ''"
                        :team="savedEntry.team.length > 0 ? savedEntry.team[0].title : ''"
                        :geschlecht="savedEntry.geschlecht"
                        :pensum="savedEntry.pensum"

                        id="andererAbschlussgrund"
                        :disabled="checkDisabledCurrentPage(step)"
                      ></Abschlusstext>
                      <div v-if="errors['abschlussgrundText']" class="text-rot text-f5 font-medium">{{ errors['abschlussgrundText'] }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>

          <!-- Step 2: Überprüfung und Anpassung VG1 -->
          <div v-if="step == 2 || step == 3 || step == 4 || step == 5">
            <div class="w-full grid grid-cols-1 gap-4">
              <p>Klicke in den Text um ihn zu bearbeiten.</p>
              <div class="flex items-center gap-2 justify-between">
                <div v-if="step == 4">
                  <div class="grid grid-cols-1 gap-2">
                    <select 
                      v-model="savedEntry.zeugnisart"
                      id="zeugnisart"
                      class="w-60"
                      :disabled="checkDisabledCurrentPage(step)"
                      @change="changeEinleittext()"
                      @focus="scrollToField"
                    >
                      <option value="zwischenzeugnis">Zwischenzeugnis</option>
                      <option value="arbeitszeugnis">Arbeitszeugnis</option>
                      <option value="arbeitsbestaetigung">Arbeitsbestätigung</option>
                      <option value="arbeitszeugnisLernende">Arbeitszeugnis Lernende</option>
                    </select>
                  </div>
                </div>
                <div v-else></div>
                <div class="relative flex flex-col items-start gap-2">

                  <div class="flex items-center gap-4 text-f5">
                    <template 
                      v-if="zeugnisAiMode == 'ki' && zeugnisAiTexts.length > 0"
                    >
                      <div class="text-primary">
                        <button
                          @click="previousZeugnisAIText()"
                          :disabled="currentZeugnisAiTextIndex == 0"
                          class="btn-no-bg p-0 text-primary"
                        >
                          <i class="fa-solid fa-chevron-left"></i>
                        </button>
                        {{ currentZeugnisAiTextIndex + 1 }} | {{ zeugnisAiTexts.length }}
                        <button
                          @click="nextZeugnisAIText()"
                          :disabled="currentZeugnisAiTextIndex == zeugnisAiTexts.length - 1"
                          class="btn-no-bg p-0 text-primary"
                        >
                          <i class="fa-solid fa-chevron-right"></i>
                        </button>
                      </div>
                      <button
                        @click="rewriteZeugnis()"
                        class="btn-no-bg py-0 text-primary-600 text-f3"
                      >
                        <i class="fa-duotone fa-thin fa-repeat"></i>
                      </button>
                    </template>
                    <div 
                      class="flex items-center gap-4"
                      :title="!savedEntry.erstelltesZeugnis ? 'Das Zeugnis muss einen Inhalt haben, bevor die KI es umschreiben kann.' : ''"
                      :class="!savedEntry.erstelltesZeugnis ? 'cursor-not-allowed' : ''"
                    >
                      <button
                        @click="setZeugnisAIGenerationMode('template')"
                        class="btn-no-bg p-0"
                        :class="zeugnisAiMode == 'template' ? 'text-primary' : ''"
                        :disabled="checkDisabledCurrentPage(step) || !zeugnisAiOn"
                      >
                        Template
                      </button>
                      
                      <button
                        @click="setZeugnisAIGenerationMode('rechtschreibpruefung')"
                        class="btn-no-bg p-0"
                        :class="zeugnisAiMode == 'rechtschreibpruefung' ? 'text-primary' : ''"
                        :disabled="checkDisabledCurrentPage(step) || !zeugnisAiOn"
                      >
                        Rechtschreibprüfung
                      </button>
                      
                      <button
                      @click="setZeugnisAIGenerationMode('ki')"
                        class="btn-no-bg p-0"
                        :class="zeugnisAiMode == 'ki' ? 'text-primary' : ''"
                        :disabled="checkDisabledCurrentPage(step) || !zeugnisAiOn"
                      >
                        KI
                      </button>
                    </div>

                    <div class="flex items-center">
                      <input type="checkbox" v-model="zeugnisAiOn" class="checkbox" id="toggleZeugnis" :disabled="!savedEntry.erstelltesZeugnis && checkDisabledCurrentPage(step)"></input>
                      <label for="toggleZeugnis" class="switch">
                        <div class="circle">
                          <i class="fa-duotone fa-thin fa-robot"></i>
                        </div>
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 
              <div 
                class="p-8 border border-solid border-gray-300 rounded"
                v-html="savedEntry.erstelltesZeugnis"
              ></div>
              -->

              <div class="mb-8">
                <!-- html editor -->
                <div 
                  class="generated-zeugnis"
                >
                  <div class="zeugnis-header">
                    <div class="header-title">{{ zeugnisarten[savedEntry.zeugnisart] }}</div>
                    <div class="header-image-container">
                      <img :src="SITEURL + 'assets/ssbl.jpg'" class="header-image" />
                    </div>
                    <div class="header-text">
                      {{ headerText }}
                    </div>
                  </div>

                  <div class="font-bold">{{ savedEntry.vorname }} {{ savedEntry.nachname }}, geb. {{ formatDate(savedEntry.geburtsdatum) }}<template v-if="savedEntry.heimatort">, von {{ savedEntry.heimatort }}</template></div>

                  <div @click="showToolbar" class="relative">
                    <quill-editor theme="snow" v-model:content="savedEntry.erstelltesZeugnis" contentType="html" :options="editorSettings" :enable="!checkDisabledCurrentPage(step) && savedEntry.aktuellerSchritt != 'abgeschlossen'" :class="editorFocused ? 'show-toolbar' : 'hide-toolbar'" />
                  </div>

                  <div class="grid grid-cols-2 mt-20">
                    <div class="flex flex-col">
                      <div>
                        {{ savedEntry.vorgesetzter[0].fullName }}
                      </div>
                      <div class="text-f5">
                        {{ savedEntry.vorgesetzter[0].bezeichnung ?? 'Vorgesetzter' }}
                      </div>
                    </div>
                    <div class="flex flex-col">
                      <div>
                        {{ savedEntry.hrVerantwortlicher[0].fullName }}
                      </div>
                      <div class="text-f5">
                        {{ savedEntry.hrVerantwortlicher[0].bezeichnung ?? 'HR Business-Partner' }}
                      </div>
                    </div>
                  </div>

                  <div class="zeugnis-footer">
                    <div>
                      <div class="footer-title">SSBL Stiftung für selbstbestimmtes und begleitetes Leben</div>
                      <div class="footer-text">
                        Rathausen 2, 6020 Emmen
                        <br>
                        T 041 269 35 00
                        <br>
                        info@ssbl.ch · www.ssbl.ch
                      </div>
                    </div>

                    <div>
                      <div class="footer-title">Unsere Standorte</div>
                      <div class="footer-text">
                        Buchrain | Emmen<br>
                        Hitzkirch | Knutwil | Luzern-Allmend<br>
                        Luzern-Littau | Pfaffnau | Reiden<br>
                        Schüpfheim | Wolhusen
                      </div>
                    </div>
                    <div>
                      <img :src="SITEURL + 'assets/ssbl-zertifikate.jpg'" class="footer-image" />
                      Spendenkonto 2222 / 2<br>
                      IBAN CH61 0900 0000 6002 2224 4
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="loading" class="fixed top-0 left-0 w-full h-full bg-white bg-opacity-50 flex items-center justify-center">
                <i class="fa-solid fa-spinner fa-spin"></i>
              </div>
            </div>

            <div class="flex justify-end items-end gap-4">
              <button @click="downloadWord()" class="btn btn-secondary">
                Download Word
              </button>
              <button @click="downloadPDF()" class="btn btn-secondary">
                Download PDF
              </button>
            </div>

          </div>


          <div v-if="step == 6">
            <div class="w-full grid grid-cols-1 gap-4">
              <p>Das Zeugnis wurde erfolgreich erstellt und steht zum Download bereit.</p>
              <div class="flex justify-end items-end gap-4">
                <button @click="downloadWord()" class="btn btn-secondary">
                  Download Word
                </button>
                <button @click="downloadPDF()" class="btn btn-secondary">
                  Download PDF
                </button>
              </div>
            </div>
          </div>
        </div>

      </template>

      <div v-if="navTab == 'einstellungen'">
        <div class="flex justify-between mb-16">
          <h1 class="text-f2 text-primary font-extrabold">
            Einstellungen
          </h1>

          <div class="flex items-center gap-2">
            <div class="border-primary border-solid border bg-white rounded-full w-10 h-10 flex items-center justify-center">
              <i class="fa-duotone fa-thin fa-user text-primary"></i>
            </div>
            <div class="text-f6 text-primary">{{ currentUser.email }}</div>
          </div>
        </div>

        <div class="grid grid-cols-2 gap-8">

          <div class="col-span-2 grid grid-cols-1 gap-2">
            <label for="model">Model</label>
            <select v-model="settings.model" id="model">
              <option v-for="model in possibleModels" :value="model">{{ model }}</option>
            </select>
          </div>
          <div class="grid grid-cols-1 gap-2 s:col-span-2">
            <label for="temperature">
              Temperature
              <div class="tooltip"><i class="fa-regular fa-circle-info"></i>
                <span class="tooltiptext">Steuert die Kreativität der KI. Niedrigere Werte führen zu vorhersehbareren und konsistenteren Antworten, während höhere Werte die Antworten vielfältiger und kreativer machen.</span>
              </div>
            </label>
            <input
              type="number" v-model="settings.temperature" id="temperature" step="0.1" min="0" max="2"
              :disabled="settings.model == 'o1-mini' || settings.model == 'o1-preview'"
            ></input>
          </div>
          <div class="grid grid-cols-1 gap-2 s:col-span-2">
            <label for="topP">
              Top P
              <div class="tooltip"><i class="fa-regular fa-circle-info"></i>
                <span class="tooltiptext">Begrenzt die Auswahl auf die wahrscheinlichsten Wörter. Ein Wert nahe 1.0 berücksichtigt viele Optionen (mehr Vielfalt), während ein niedrigerer Wert nur die sichersten Wörter verwendet und die Antwort deterministischer macht.</span>
              </div>
            </label>
            <input
              type="number" v-model="settings.topP" id="topP" step="0.1" min="0" max="1"
              :disabled="settings.model == 'o1-mini' || settings.model == 'o1-preview'"
            ></input>
          </div>
          <div class="grid grid-cols-1 gap-2 s:col-span-2">
            <label for="frequencyPenalty">
              Frequency Penalty
              <div class="tooltip"><i class="fa-regular fa-circle-info"></i>
                <span class="tooltiptext">Reduziert die Wahrscheinlichkeit, dass sich bereits verwendete Wörter wiederholen. Höhere Werte verringern Wiederholungen stärker, während 0 keine Strafe für häufige Wörter bedeutet.</span>
              </div>
            </label>
            <input
              type="number" v-model="settings.frequencyPenalty" id="frequencyPenalty" step="0.1" min="0" max="2"
              :disabled="settings.model == 'o1-mini' || settings.model == 'o1-preview'"
            ></input>
          </div>
          <div class="grid grid-cols-1 gap-2 s:col-span-2">
            <label for="presencePenalty">
              Presence Penalty
              <div class="tooltip"><i class="fa-regular fa-circle-info"></i>
                <span class="tooltiptext">Erhöht die Wahrscheinlichkeit, dass neue Wörter in der Antwort erscheinen. Höhere Werte fördern die Verwendung neuer Begriffe, während 0 keine Beeinflussung bewirkt.</span>
              </div>
            </label>
            <input
              type="number" v-model="settings.presencePenalty" id="presencePenalty" step="0.1" min="0" max="2"
              :disabled="settings.model == 'o1-mini' || settings.model == 'o1-preview'"
            ></input>
          </div>

          <h2 class="font-bold text-f3 col-span-2">Vorlagen Prompting</h2>
          <div class="col-span-2 grid grid-cols-1 gap-2">
            <label for="systemMessageVorlagen">System Message Vorlagen</label>
            <textarea v-model="settings.systemMessageVorlagen" id="systemMessageVorlagen" rows="4"></textarea>
          </div>

          <div class="col-span-2 grid grid-cols-1 gap-2">
            <label>Vorlagen Multishot Prompts</label>
            <div class="flex gap-2" v-for="beispielCallVorlagen in settings.beispielCallsVorlagen">
              <div class="grid grid-cols-2 s:grid-cols-1 gap-2 grow">
                <div class="relative flex flex-col">
                  <label>User Call</label>
                  <textarea v-model="beispielCallVorlagen.userCall" rows="4"></textarea>
                </div>
                <div class="relative flex flex-col">
                  <label>Antwort</label>
                  <textarea v-model="beispielCallVorlagen.assistantAntwort" rows="4"></textarea>
                </div>
              </div>

              <button @click="removeBeispielCallVorlagen(beispielCallVorlagen)" class="btn-no-bg p-0 grow-0">
                <i class="fa-solid fa-trash"></i>
              </button>
            </div>

            <button @click="addBeispielCallVorlagen()" class="btn">+ Beispiel Call</button>
          </div>

          <h2 class="font-bold text-f3 col-span-2">Zeugnis Prompting</h2>
          <div class="col-span-2 grid grid-cols-1 gap-2">
            <div>
              <label for="systemMessageZeugnis">System Message Zeugnis</label>
              <div class="text-sm text-gray-500">Mit {Zeitform} wird die ausgewählte Zeitform (präsens oder präteritum) eingefügt.</div>
            </div>
            <textarea v-model="settings.systemMessageZeugnis" id="systemMessageZeugnis" rows="4"></textarea>
          </div>

          <div class="col-span-2 grid grid-cols-1 gap-2">
            <label>Zeugnis Multishot Prompts</label>
            <div class="flex gap-2" v-for="beispielCallZeugnis in settings.beispielCallsZeugnis">
              <div class="grid grid-cols-2 s:grid-cols-1 gap-2 grow">
                <div class="relative flex flex-col">
                  <label>User Call</label>
                  <textarea v-model="beispielCallZeugnis.userCall" rows="4"></textarea>
                </div>
                <div class="relative flex flex-col">
                  <label>Antwort</label>
                  <textarea v-model="beispielCallZeugnis.assistantAntwort" rows="4"></textarea>
                </div>
              </div>

              <button @click="removeBeispielCallZeugnis(beispielCallZeugnis)" class="btn-no-bg p-0 grow-0">
                <i class="fa-solid fa-trash"></i>
              </button>
            </div>

            <button @click="addBeispielCallZeugnis()" class="btn">+ Beispiel Call</button>
          </div>

          <h2 class="font-bold text-f3 col-span-2">Spellcheck Prompting</h2>
          <div class="col-span-2 grid grid-cols-1 gap-2">
            <label for="systemMessageSpellcheck">System Message Spellcheck</label>
            <textarea v-model="settings.systemMessageSpellcheck" id="systemMessageSpellcheck" rows="4"></textarea>
          </div>

          <div class="col-span-2 grid grid-cols-1 gap-2">
            <label>Spellcheck Multishot Prompts</label>
            <div class="flex gap-2" v-for="beispielCallSpellcheck in settings.beispielCallsSpellcheck">
              <div class="grid grid-cols-2 s:grid-cols-1 gap-2 grow">
                <div class="relative flex flex-col">
                  <label>User Call</label>
                  <textarea v-model="beispielCallSpellcheck.userCall" rows="4"></textarea>
                </div>
                <div class="relative flex flex-col">
                  <label>Antwort</label>
                  <textarea v-model="beispielCallSpellcheck.assistantAntwort" rows="4"></textarea>
                </div>
              </div>

              <button @click="removeBeispielCallSpellcheck(beispielCallSpellcheck)" class="btn-no-bg p-0 grow-0">
                <i class="fa-solid fa-trash"></i>
              </button>
            </div>

            <button @click="addBeispielCallSpellcheck()" class="btn">+ Beispiel Call</button>
          </div>

          <h2 class="font-bold text-f3 col-span-2">Zeugnis Spellcheck Prompting</h2>
          <div class="col-span-2 grid grid-cols-1 gap-2">
            <label for="systemMessageSpellcheck">System Message Zeugnis Spellcheck</label>
            <textarea v-model="settings.systemMessageZeugnisSpellcheck" id="systemMessageZeugnisSpellcheck" rows="4"></textarea>
          </div>

          <div class="col-span-2 grid grid-cols-1 gap-2">
            <label>Zeugnis Spellcheck Multishot Prompts</label>
            <div class="flex gap-2" v-for="beispielCallZeugnisSpellcheck in settings.beispielCallsZeugnisSpellcheck">
              <div class="grid grid-cols-2 s:grid-cols-1 gap-2 grow">
                <div class="relative flex flex-col">
                  <label>User Call</label>
                  <textarea v-model="beispielCallZeugnisSpellcheck.userCall" rows="4"></textarea>
                </div>
                <div class="relative flex flex-col">
                  <label>Antwort</label>
                  <textarea v-model="beispielCallZeugnisSpellcheck.assistantAntwort" rows="4"></textarea>
                </div>
              </div>

              <button @click="removeBeispielCallZeugnisSpellcheck(beispielCallZeugnisSpellcheck)" class="btn-no-bg p-0 grow-0">
                <i class="fa-solid fa-trash"></i>
              </button>
            </div>

            <button @click="addBeispielCallZeugnisSpellcheck()" class="btn">+ Beispiel Call</button>
          </div>

        </div>
        <div class="flex justify-end pt-12">
          <button 
            @click="navTab = null"
            class="btn"
          >
            Speichern
            <i class="fa-regular fa-floppy-disk ml-2"></i>
          </button>
        </div>
      </div>

      <div v-if="navTab == 'statistik'" class="zeugnis-uebersicht">
        <div class="grid grid-cols-2 gap-6 mb-16">
          <div class="flex justify-between">
            <h1 class="text-f2 text-primary font-extrabold">
              Statistik
            </h1>

            <div class="flex items-center space-x-4">
              <label for="inactiveSince" class="text-sm">Inaktiv seit mindestens:</label>
              <select v-model="inactiveSince" id="inactiveSince" class="form-select text-primary !pr-8" @change="filterZeugnisse()">
                <option v-for="option in inactiveSinceOptions" :value="option.value">{{ option.text }}</option>
              </select>
            </div>
          </div>

          <div class="flex items-center gap-2 justify-end">
            <div class="border-primary border-solid border bg-white rounded-full w-10 h-10 flex items-center justify-center">
              <i class="fa-duotone fa-thin fa-user text-primary"></i>
            </div>
            <div class="text-f6 text-primary">{{ currentUser.email }}</div>
          </div>
        </div>

        <div class="flex flex-col md:flex-row items-center justify-between mb-8">
          <div class="flex items-center gap-2 mb-4">
            <input
              type="checkbox"
              v-model="showAbgeschlosseneZeugnisse"
              id="showAbgeschlosseneZeugnisse"
              class="checkbox"
              @change="filterZeugnisse()"
            ></input>
            <label for="showAbgeschlosseneZeugnisse" class="switch">
              <div class="circle">
              </div>
            </label>
            Abgeschlossene Zeugnisse anzeigen
          </div>

          <div class="relative mb-4">
            <input
              type="text"
              v-model="searchQuery"
              placeholder="Suche"
              class="form-input w-full"
              @input="filterZeugnisse()"
            >
            <i class="fa-solid fa-magnifying-glass absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500"></i>
          </div>
        </div>

        <div class="">
          
          <div class="zeugnis-uebersicht-table">
            <div class="zeugnis-header flex justify-between items-center mb-8">
              <div class="text-f3 font-extrabold">Zeugnisse</div>
              <div class="text-f5 text-gray-500">Anzahl: {{ filteredZeugnisse.length }}</div>
            </div>
            
            <table>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Inaktiv seit</th>
                  <th>Aktueller Schritt</th>
                  <th>Verantwortlich</th>
                  <th>Mail erneut senden</th>
                  <th>zum Zeugnis</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="zeugnis in filteredZeugnisse" :key="zeugnis.uid">
                  <td>{{ zeugnis.vorname }} {{ zeugnis.nachname }}</td>
                  <td>{{ formatDate(zeugnis.dateUpdated) }}</td>
                  <td 
                    :class="[zeugnis.aktuellerSchritt ? 'text-primary' : 'text-rot']"
                  >
                    {{ zeugnis.aktuellerSchritt ?? 'nicht definiert' }}
                  </td>
                  <td 
                    :class="[getVerantwortlichePerson(zeugnis).fullName == 'nicht zugewiesen' ? 'text-rot' : 'text-primary']"
                  >
                    {{ getVerantwortlichePerson(zeugnis).fullName }}
                  </td>
                  <td >
                    <button 
                      @click="sendStatistikEmailNotification(zeugnis)"
                      class="btn"
                      v-if="zeugnis.aktuellerSchritt && zeugnis.aktuellerSchritt != 'Abgeschlossen' && getVerantwortlichePerson(zeugnis).fullName != 'nicht zugewiesen'"
                    >
                      <i class="fa-solid fa-envelope"></i>
                    </button>

                  </td>
                  <td >

                    <a
                      :href="`${SITEURL}zeugnis/${zeugnis.uid}`"
                      class="btn"
                    >
                      <i class="fa-solid fa-earth-americas"></i>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

        </div>
      </div>

      <div v-if="navTab == 'information'">
        <div class="flex justify-between mb-16">
          <h1 class="text-f2 text-primary font-extrabold">
            Information
          </h1>

          <div class="flex items-center gap-2">
            <div class="border-primary border-solid border bg-white rounded-full w-10 h-10 flex items-center justify-center">
              <i class="fa-duotone fa-thin fa-user text-primary"></i>
            </div>
            <div class="text-f6 text-primary">{{ currentUser.email }}</div>
          </div>
        </div>

        <div class="" v-html="information">
        </div>
      </div>

      <div class="w-full mt-12" v-if="!checkDisabledCurrentPage(step) && savedEntry.aktuellerSchritt != 'abgeschlossen' && navTab == null && (step != 1 || activeCategoryIndex == 0)">
        <label for="nachrichtField">Nachricht (Pflichtfeld bei Rückgabe an letzte Person)</label>
        <div class="grid grid-cols-1 w-full">
          <textarea
            id="nachrichtField"
            v-model="nachrichtField"
            class=""
          ></textarea>
        </div>
      </div>

      <div class="flex justify-between pt-4 gap-2" v-if="categories && navTab == null">
        <button 
          @click="sendBackToHR()"
          class="btn"
          :disabled="!nachrichtField"
          v-if="step == 1 && activeCategoryIndex == 0 && savedEntry.aktuellerSchritt == 'bewertung' && currentUser.id == savedEntry.vorgesetzter[0].id"
        >
          zurückgeben an {{ savedEntry.hrVerantwortlicher[0].fullName }} (HR)
        </button>
        <button 
          @click="sendBackToVorgesetzten()"
          class="btn"
          :disabled="!nachrichtField"
          v-else-if="step == 3 && savedEntry.aktuellerSchritt == 'ueberpruefungDurchVg2' && currentUser.id == savedEntry.hoehererVorgesetzter[0].id"
        >
          zurückgeben an {{ savedEntry.vorgesetzter[0].fullName }} (VG1)
        </button>
        <button 
          @click="previousStep()"
          class="btn"
          v-else-if="step > 0" 
        >
          Zurück
        </button>

        <button
          class="btn"
          @click="correctPersonalien()"
          v-else-if="step == 0 && savedEntry.aktuellerSchritt == 'bewertung' && savedEntry.gespeicherteOptionen.length == 0 && currentUser.id == savedEntry.hrVerantwortlicher[0].id"
        >
          Korrektur
        </button>

        <div v-else></div>


        <button
          @click="sendToVorgesetzter()"
          :disabled="checkDisabled(step + 1) && step != 0"
          class="btn"
          v-if="step == 0 && savedEntry.aktuellerSchritt == 'personalienAngeben' && savedEntry.zeugnisart != 'arbeitsbestaetigung'"
        >
          weiter an {{ (savedEntry.vorgesetzter && savedEntry.vorgesetzter.length > 0) ? savedEntry.vorgesetzter[0].fullName : 'Vorgesetzten' }} (VG1)
        </button>

        <button
          @click="generateArbeitsbestätigung()"
          :disabled="checkDisabled(step + 1) && step != 0"
          class="btn"
          v-else-if="step == 0 && savedEntry.aktuellerSchritt == 'personalienAngeben' && savedEntry.zeugnisart == 'arbeitsbestaetigung'"
        >
          weiter zur Überprüfung
        </button>

        <button 
          @click="sendToNächsterVorgesetzter()"
          :disabled="checkDisabled(step + 1)"
          class="btn"
          v-else-if="step == 2 && savedEntry.aktuellerSchritt == 'ueberpruefungDurchVg1' && currentUser.id == savedEntry.vorgesetzter[0].id"
        >
          weiter an {{ savedEntry.hoehererVorgesetzter[0].fullName }} (VG2)
        </button>

        <button 
          @click="sendToHRBP()"
          :disabled="checkDisabled(step + 1)"
          class="btn"
          v-else-if="step == 3 && savedEntry.aktuellerSchritt == 'ueberpruefungDurchVg2' && currentUser.id == savedEntry.hoehererVorgesetzter[0].id"
        >
          weiter an {{ savedEntry.hrVerantwortlicher[0].fullName }} (HR)
        </button>

        <button 
          @click="nextStep()"
          v-else-if="step < steps.length - 1 && step < 4"
          class="btn"
          :disabled="checkDisabled(step + 1)"
        >
          <template v-if="step == 1 && activeCategoryIndex < categories.length - 1">Weiter zur Beurteilung {{ categories[activeCategoryIndex + 1].title }}</template>
          <template v-else>Weiter</template>
        </button>

        <button
          @click="giveToUnterschrift()"
          class="btn"
          v-else-if="step == 4 && savedEntry.aktuellerSchritt == 'ueberpruefungDurchHr' && currentUser.id == savedEntry.hrVerantwortlicher[0].id"
          :disabled="savedEntry.aktuellerSchritt != 'ueberpruefungDurchHr' || currentUser.id != savedEntry.hrVerantwortlicher[0].id"
        >
          Zur Unterschrift geben
        </button>
        <button 
          @click="nextStep()"
          v-else-if="step==4"
          class="btn"
          :disabled="checkDisabled(step + 1)"
        >
          Weiter
        </button>

        <button
          @click="abschliessen()"
          class="btn"
          v-else-if="step == 5 && savedEntry.aktuellerSchritt == 'zurUnterschrift' && currentUser.id == savedEntry.hrVerantwortlicher[0].id"
          :disabled="savedEntry.aktuellerSchritt != 'zurUnterschrift' || currentUser.id != savedEntry.hrVerantwortlicher[0].id"
        >
          Abschliessen
        </button>

        <div v-else></div>
      </div>

      <div class="border-0 border-t border-gray-400 border-solid pt-8 mt-8 grid grid-cols-1 gap-2" v-if="navTab == null">
        <div v-for="(nachricht, nIndex) in savedEntry.nachrichten" class="text-gray-500">
          
          <template v-if="nachricht.zugewiesenePerson[0].id == nachricht.autor[0].id && nachricht.nachrichtText">
            ({{ formatDateTime(nachricht.datum) }}) {{ nachricht.autor[0].fullName }} {{ nachricht.nachrichtText }}
          </template>
          <template v-else>
          ({{ formatDateTime(nachricht.datum) }}) {{ nachricht.autor[0].fullName }}:
            <template v-if="nIndex == 0 || textToStep[nachricht.aktuellerSchritt] > textToStep[savedEntry.nachrichten[nIndex - 1].aktuellerSchritt]">Zugewiesen </template>
            <template v-else>Zurückgegeben </template>
            an {{ (nachricht.zugewiesenePerson && nachricht.zugewiesenePerson.length > 0) ? nachricht.zugewiesenePerson[0].fullName : "" }}
            <template v-if="nachricht.nachrichtText">mit Nachricht "{{ nachricht.nachrichtText }}"</template>
          </template>

        </div>
      </div>

      <!-- Overlay asking if you want to start again -->
      <div class="overlay" v-if="showOverlay">
        <div class="overlay-content grid grid-cols-1 gap-8">
          <h2 class="text-f3">Neues Zeugnis erstellen?</h2>
          <div class="flex justify-between gap-8">
            <button @click="showOverlay = false" class="btn">Abbrechen</button>
            <a :href="BASEURL" class="btn text-sm no-underline">Neues Zeugnis</a>
          </div>
        </div>
      </div>


      <div class="overlay" v-if="showingSentOverlay">
        <div class="overlay-sent grid grid-cols-1 gap-8">
          <div class="overlay-sent-content">
            <!-- Overlay showing "sent overlay message" and symbol to show success -->
            <div class="flex items-center gap-2 flex-col text-center">
              <div class="flex items-center gap-2 mb-4">
                <div class="w-10 h-10 rounded-full flex items-center justify-center bg-green-500">
                  <i class="fa-solid fa-check text-white"></i>
                </div>
                <h2 class="text-f2 inline">Zeugnis gespeichert</h2>
              </div>
              <div class="text-f4 text-gray-500 mb-4">{{ sentOverlayMessage }}</div>
              <div class="text-f5 text-gray-500">Du kannst dieses Browserfenster nun schliessen.</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Navigation rechts -->
    <div class="navigation">
      <div class="flex flex-col gap-9">
        <button 
          @click="toggleNav('einstellungen')"
          class="navigation-button"
          :class="navTab == 'einstellungen' ? 'current-navigation' : ''"
          tabindex="-1"
          v-if="currentUser.admin"
        >
          <div class="navigation-circle">
            <i class="fa-duotone fa-thin fa-gear"></i>
          </div>
          <div class="navigation-text">Einstellungen</div>
        </button>

        <button 
          @click="toggleNav('statistik')"
          class="navigation-button"
          :class="navTab == 'statistik' ? 'current-navigation' : ''"
          tabindex="-1"
          v-if="currentUser.admin"
        >
          <div class="navigation-circle">
            <i class="fa-duotone fa-thin fa-chart-simple"></i>
          </div>
          <div class="navigation-text">Statistik</div>
        </button>


        <button 
          @click="toggleNav('information')"
          class="navigation-button"
          :class="navTab == 'information' ? 'current-navigation' : ''"
          tabindex="-1"
        >
          <div class="navigation-circle">
            <i class="fa-duotone fa-thin fa-circle-info"></i>
          </div>
          <div class="navigation-text">Information</div>
        </button>

        <button 
          @click="navTab = null"
          class="navigation-button navigation-back-button"
          tabindex="-1"
          v-if="navTab != null"
        >
          <div class="navigation-circle">
            <i class="fa-solid fa-turn-down-left"></i>
          </div>
          <div class="navigation-text">zurück</div>
        </button>

      </div>

      <!-- Alerts -->
      <div class="alerts">
        <TransitionGroup name="alerts">
          <div v-for="(alert, index) in alerts" :key="index" >
            <div class="flex items-center gap-1">
              <div class="w-5 h-5 rounded-full flex items-center justify-center alert-robot" :class="alert.type">
                <i class="fa-duotone fa-thin fa-robot text-white text-f6"></i>
              </div>
              <div class="text-f4 font-medium">
                <template v-if="alert.type == 'error'">Hoppla</template>
                <template v-else-if="alert.type == 'warning'">Achtung</template>
                <template v-else-if="alert.type == 'info'"></template>
                <template v-else-if="alert.type == 'success'">Juhui</template>
              </div>
            </div>
            <div class="alert text-f4" :class="alert.type">
              {{ alert.message }}
            </div>
          </div>
        </TransitionGroup>
      </div>
      <div>
        <div 
          class="text-f5 text-gray-300 text-center px-8"
          v-if="step == 0 && savedEntry.aktuellerSchritt == 'bewertung' && savedEntry.gespeicherteOptionen.length == 0 && currentUser.id == savedEntry.hrVerantwortlicher[0].id"
        >
          Falls Du einen Fehler bemerkst, kannst du immer noch zurück zur Korrektur, beachte jedoch bitte dass der Vorgesetzte dann jedoch zwei Emails erhält.
        </div>
      </div>
    </div>
  </div>

</template>

<script setup lang="ts">
import {ref, Ref, onMounted} from "vue";
import {BASEURL, SITEURL} from "@libTs/cms.globals.js";
import axios from "axios";
import { ZeugnisQuery, ZeugnisMutation, UsersQuery, FunktionenQuery, AbschlussgruendeQuery, BereicheQuery, ZeugnisseQuery, InformationQuery } from "../gql/vorlagen";
import StarRating from './StarRating.vue';
import VorlageText from './VorlageText.vue';
import Einleittext from "./Einleittext.vue";
import Abschlusstext from "./Abschlusstext.vue";
import Dropdown from './Dropdown.vue';
import FunktionenDropdown from './FunktionenDropdown.vue';
import { QuillEditor, Quill } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import { create } from "domain";

const {id, defaultSettings, gqlToken, generatorUrl, currentUser, headerText} = defineProps({
  gqlToken: {
    type: String,
    required: true
  },
  defaultSettings: {
    type: Object,
    required: false,
    default: {
      model: "gpt-4o-mini",
      temperature: 1,
      topP: 1,
      frequencyPenalty: 0,
      presencePenalty: 0,
      systemMessageVorlagen: "Du bist ein HR-Angestellter, welcher Teile für die Vorlagen der Arbeitszeugnisse ein wenig umschreibt. Gib als Antwort jeweils nur die Umformulierung an.",
      systemMessageZeugnis: "Du bist ein HR-Angestellter, welcher Arbeitszeugnisse ein umschreibt, damit sie besser fliessen. Gib als Antwort jeweils nur die Umformulierung mit HTML-Formatierung an."
    }
  },
  id: {
    type: String,
    required: false,
    default: null
  },
  generatorUrl: {
    type: String,
    required: true
  },
  currentUser: {
    type: Object,
    required: true
  },
  headerText: {
    type: String,
    required: true
  }
});

const zeugnisarten = {
  "arbeitszeugnis": "Arbeitszeugnis",
  "zwischenzeugnis": "Zwischenzeugnis",
  "arbeitsbestaetigung": "Arbeitsbestätigung",
  "arbeitszeugnisLernende": "Arbeitszeugnis Lernende",
};

const LEISTUNGSSTUFEN = [
  "ungenuegendeLeistung",
  "befriedigendeLeistung",
  "guteLeistung",
  "sehrGuteLeistung"
];

const graphqlUrl = BASEURL + 'actions/graphql/api';

const categories: Ref<any> = ref(null);

const users: Ref<any> = ref(null);

const funktionen: Ref<any> = ref([]);
const abschlussgründe: Ref<any> = ref([]);
const bereiche: Ref<any> = ref([]);

const activeCategoryIndex = ref(0);

const steps = [
  "Personalien",
  "Beurteilung",
  "Überprüfung VG 1",
  "Überprüfung VG 2",
  "Abschluss HR",
  "Zur Unterschrift",
  "Abgeschlossen",
];
const step = ref(0);

const textToStep = {
  "personalienAngeben": 0,
  "bewertung": 1,
  "ueberpruefungDurchVg1": 2,
  "ueberpruefungDurchVg2": 3,
  "ueberpruefungDurchHr": 4,
  "zurUnterschrift": 5,
  "abgeschlossen": 6,
};

const settingsOpen = ref(false);
const navTab: Ref<null|string> = ref(null);

const showOverlay = ref(false);

const showingSentOverlay = ref(false);
const sentOverlayMessage = ref("");

const zeugnisAiGenerated = ref(false);
const zeugnisAiMode = ref('template');
const zeugnisAiTexts: Ref<any> = ref([]);

const zeugnisAiOn = ref(false);

const currentZeugnisAiTextIndex = ref(0);
const loading = ref(false);

const alerts = ref([
]);

const stepToSave = ref(null);
const createNachricht = ref(false);

const savedEntry = ref(null);

const nachrichtField = ref("");
const zugewiesenePerson = ref(null);
const zurückAnLetztePerson = ref(false);

const possibleModels = [
  "gpt-4o-mini",
  "gpt-3.5-turbo",
  "o1-mini",
  "o1-preview"
];

const settings = ref(defaultSettings);

const editorFocused = ref(false);

const Inline = Quill.import('blots/inline');
const Block = Quill.import('blots/block');
const Container = Quill.import('blots/container');
const List = Quill.import('formats/list');
const ListItem = Quill.import('formats/list/item');


class Fixzeit extends Inline {
  static create(value) {
    let node = super.create()
    return node
  }
}

Fixzeit.blotName = 'fixzeit';
Fixzeit.tagName = 'fixzeit';

class Abteilung extends Inline {
  static create(value) {
    let node = super.create()
    return node
  }
}

Abteilung.blotName = 'abteilungtext';
Abteilung.tagName = 'abteilungtext';


class AListItem extends ListItem {
  static create(value) {
    console.log("Creating AListItem with value:", value);

    let node = super.create(value);
    return node;
  }

  static formats(domNode) {
    return domNode.tagName === this.tagName ? undefined : super.formats(domNode);
  }

  format(name, value) {
    console.log("Formatting AListItem with name:", name, "and value:", value);
    if (name === List.blotName && !value) {
      this.replaceWith(Parchment.create(this.statics.scope));
    } else {
      super.format(name, value);
    }
  }

  remove() {
    console.log("Removing AListItem with prev:", this.prev, "and next:", this.next);
    if (this.prev == null && this.next == null) {
      console.log("Removing AListItem with no siblings, removing parent instead");
      this.parent.remove();
    } else {
      super.remove();
    }
  }

  insertAt(index, value, def) {
    console.log("Inserting AListItem at index:", index, "with value:", value, "and def:", def);

    // check if previous sibling is an AListItem and empty. If so, end list
    if (this.prev != null && this.prev.statics.blotName === this.statics.blotName && this.prev.length() === 0) {
      console.log("Previous sibling is an empty AListItem, removing it");
      this.prev.remove();
    }


    if (def != null) return super.insertAt(index, value, def);
    if (value.length === 0) return;
    let lines = value.split('\n');
    let text = lines.shift();
    if (text.length > 0) {
      if (index < this.length() - 1 || this.children.tail == null) {
        super.insertAt(Math.min(index, this.length() - 1), text);
      } else {
        this.children.tail.insertAt(this.children.tail.length(), text);
      }
      this.cache = {};
    }
    let block = this;
    lines.reduce(function(index, line) {
      block = block.split(index, true);
      block.insertAt(0, line);
      return line.length;
    }, index + text.length);
  }

  replaceWith(name, value) {
    console.log("Replacing AListItem with name:", name, "and value:", value);

    this.parent.isolate(this.offset(this.parent), this.length());
    if (name === this.parent.statics.blotName) {
      this.parent.replaceWith(name, value);
      return this;
    } else {
      this.parent.unwrap();
      return super.replaceWith(name, value);
    }
  }
}
AListItem.blotName = 'a-list-item';
AListItem.className = 'a-list-item';


class Aufgaben extends List {
  static create(value) {
    let node = super.create(value)
    return node
  }
}

Aufgaben.blotName = 'aufgaben';
Aufgaben.tagName = 'aufgaben';
Aufgaben.allowedChildren = [ListItem];
Aufgaben.defaultChild = ListItem;


const editorSettings = {
  modules: {
    toolbar: ['bold', 'italic', 'underline', { 'list': 'bullet' }],
  },
  formats: [
    'bold', 'italic', 'underline', 'list', 'abteilungtext', 'aufgaben', 'fixzeit'
  ],
  theme: 'snow'
}

const loadingWord = ref(false);
const loadingPDF = ref(false);

const errors = ref({});

const allZeugnisse = ref([]);
const filteredZeugnisse = ref([]);
const searchQuery = ref("");

const inactiveSince = ref(30);
const showAbgeschlosseneZeugnisse = ref(false);

const inactiveSinceOptions = ref([
  {value: 0, text: 'Alle'},
  {value: 1, text: '1 Tag'},
  {value: 7, text: '1 Woche'},
  {value: 30, text: '1 Monat'},
  {value: 90, text: '3 Monate'},
]);

const information = ref("");

const positiverAbschlusstext = ref(true);


onMounted(() => {
  Quill.register(Abteilung);
  Quill.register(AListItem);

  Quill.register(Aufgaben);
  Quill.register(Fixzeit);

  window.addEventListener("beforeunload", function (e) {
    var confirmationMessage = 'Wenn du die Seite verlässt, werden ungespeicherte Daten verloren. '
                            + 'Du kannst die Daten speichern, indem du auf "weiter" oder "zurück" klickst.';

    (e || window.event).returnValue = confirmationMessage; //Gecko + IE
    return confirmationMessage; //Gecko + Webkit, Safari, Chrome etc.
  });

  getZeugnisse();

  if(id) {
    getSavedEntry();
  }
  else {
    savedEntry.value = {
        id: null,
        slug: "",
        uid: "",
        vorname: "",
        nachname: "",
        heimatort: "",
        geschlecht: "m",
        geburtsdatum: "",
        anstellungSeit: "",
        anstellungBis: "",
        pensum: "",
        gespeicherteOptionen: [],
        freierText: "",
        erstelltesZeugnis: "",
        zeugnisart: "arbeitszeugnis",
        vorgesetzter: [],
        aktuellerSchritt: "personalienAngeben",
        hrVerantwortlicher: [{
          id: String(currentUser.id),
          fullName: currentUser.fullName,
          email: currentUser.email,
          firstName: currentUser.firstName,
          lastName: currentUser.lastName,
        }],
        hoehererVorgesetzter: [],
        funktion: [],
        bereich: [],
        abteilung: [],
        team: [],
        abschlussgrund: [],
        andererAbschlussgrund: "",
        nachrichten: [],
        angepassterEinleittext: "",
    };
    
    categories.value = [];
  }

  getUsers();
  getFunktionen();
  getAbschlussgründe();
  getBereiche();
  getInfo();
});

const getVorlagen = async () => {
  
    let vorlagen = (savedEntry.value.funktion.length > 0 ? savedEntry.value.funktion[0].beurteilungsvorlagen : []) ?? [];

    let tempCategories: any = [];

    vorlagen.forEach((vorlage: any) => {

      vorlage.rating = 0;
      vorlage.text = "";
      vorlage.aiGenerationMode = 'template';
      vorlage.aiTexts = [];
      vorlage.rechtschreibeText = "";
      vorlage.loading = false;
      vorlage.currentAiTextIndex = null;

      vorlage.aiOn = false;

      let foundCategory = tempCategories.find((category: any) => {
        return category.id === vorlage.beurteilungskategorie[0].id;
      });

      if (foundCategory === undefined) {
        tempCategories.push({
          title: vorlage.beurteilungskategorie[0].title,
          id: vorlage.beurteilungskategorie[0].id,
          vorlagen: [ vorlage ]
        });
      }
      else {
        foundCategory.vorlagen.push(vorlage);
      }
    });

    categories.value = tempCategories;

}


const getUsers = async () => {
  axios.post(graphqlUrl, {
        query: UsersQuery
      }, {
        headers: {
          'Authorization': "Bearer " + gqlToken
        }
      }
  ).then((response) => {
    users.value = response.data.data.users;
  })
}

const getInfo = async () => {
  axios.post(graphqlUrl, {
        query: InformationQuery
      }, {
        headers: {
          'Authorization': "Bearer " + gqlToken
        }
      }
  ).then((response) => {
    information.value = response.data.data.entry.information;
  })
}


const getFunktionen = async () => {
  axios.post(graphqlUrl, {
        query: FunktionenQuery
      }, {
        headers: {
          'Authorization': "Bearer " + gqlToken
        }
      }
  ).then((response) => {
    funktionen.value = response.data.data.funktionenEntries;
  })
}

const getBereiche = async () => {
  axios.post(graphqlUrl, {
        query: BereicheQuery
      }, {
        headers: {
          'Authorization': "Bearer " + gqlToken
        }
      }
  ).then((response) => {
    bereiche.value = response.data.data.bereicheEntries;
  })
}


const getAbschlussgründe = async () => {
  axios.post(graphqlUrl, {
        query: AbschlussgruendeQuery
      }, {
        headers: {
          'Authorization': "Bearer " + gqlToken
        }
      }
  ).then((response) => {
    abschlussgründe.value = response.data.data.abschlussgruendeEntries;
  })
}


const nextStep = () => {

  if(step.value == 1 && activeCategoryIndex.value == categories.value.length - 1) {
    if(savedEntry.value.aktuellerSchritt == 'bewertung') {
      stepToSave.value = 'ueberpruefungDurchVg1';
    }

    if((!savedEntry.value.erstelltesZeugnis || savedEntry.value.aktuellerSchritt == 'bewertung' || savedEntry.value.aktuellerSchritt == 'ueberpruefungDurchVg1') && (currentUser.id == savedEntry.value.vorgesetzter[0].id || currentUser.admin)) {
      generateZeugnis();
    }
  }

  if(step.value == 1 && categories.value[activeCategoryIndex.value + 1]?.title == "Abschlusstext" && (savedEntry.value.andererAbschlussgrund == "" || savedEntry.value.andererAbschlussgrund == null)) {
    savedEntry.value.andererAbschlussgrund = savedEntry.value.abschlussgrund[0].abschlusstextPositiv;
  }

  savePageData()?.then(() => {
    if(!window.location.pathname.includes('zeugnis')) {
      window.history.pushState({}, '', '/zeugnis/' + savedEntry.value.uid);     
    }
  });

  if(step.value == 1 && activeCategoryIndex.value < categories.value.length - 1) {
    activeCategoryIndex.value++;
  }
  else {
    step.value++;
  }

  window.scrollTo({ top: 0, behavior: 'smooth' });
}

const previousStep = () => {
  if(step.value == 3 && savedEntry.value.aktuellerSchritt == 'bewertung') {
    stepToSave.value = 'ueberpruefungDurchVg1';
  }

  savePageData();

  if (step.value == 1 && activeCategoryIndex.value > 0) {
    activeCategoryIndex.value--;
  }
  else {
    step.value--;
  }

  window.scrollTo({ top: 0, behavior: 'smooth' });
}


const updateText = (params: any) => {
  let categoryVorlage = categories.value[activeCategoryIndex.value].vorlagen.find((vorlage: any) => {
    return vorlage.id == params.vorlage.id;
  });

  let newRating = params.newRating;
  
  params.vorlage.rating = newRating;
  categoryVorlage.rating = newRating;

  categoryVorlage.text = categoryVorlage[LEISTUNGSSTUFEN[newRating - 1]];


  if(categoryVorlage.aiGenerationMode == 'ki' || categoryVorlage.aiGenerationMode == 'rechtschreibpruefung') {
    updateAItext(categoryVorlage);
  }
}

const changeVorlageKiMode = (params: any) => {
  
  params.vorlage.aiOn = true;

  if(params.vorlage.rating > 0) {
    setAIGenerationMode(params.mode, params.vorlage);
  }
}

const switchVorlageKiMode = (vorlage: any) => {
  if(!vorlage.aiOn) {
    setAIGenerationMode('template', vorlage);
  }
}

const updateAItext = async (vorlage: any) => {
  if (vorlage.aiGenerationMode == "ki") {

    let rewordedVorlage = await rewordVorlage(vorlage);
    vorlage.aiTexts.push(rewordedVorlage);
    vorlage.currentAiTextIndex = vorlage.aiTexts.length - 1;

    vorlage.text = rewordedVorlage;
  
  }
  else if(vorlage.aiGenerationMode == "rechtschreibpruefung") {
    let spellcheckedVorlage = await spellcheckVorlage(vorlage);
    vorlage.rechtschreibeText = spellcheckedVorlage;
    vorlage.text = spellcheckedVorlage;
  }
  else {
    if(vorlage.rating > 0) {
      vorlage.text = vorlage[LEISTUNGSSTUFEN[vorlage.rating - 1]];
    }
    else {
      vorlage.text = "";
    }
  }
}

const changeEinleittext = () => {
  if(savedEntry.value.funktion.length > 0) {
    if(savedEntry.value.zeugnisart == "zwischenzeugnis" || savedEntry.value.zeugnisart == "arbeitsbestaetigung") {
      savedEntry.value.angepassterEinleittext =  `{Vorname} {Nachname} arbeitet als {Funktion} seit dem {AngestelltSeit} in der SSBL Stiftung für selbstbestimmtes und begleitetes Leben im Bereich {Bereich}, {TeamText}. Das Arbeitspensum beträgt {Pensum}%.`;
    }
    else {
      if(savedEntry.value.anstellungBis) {
        savedEntry.value.angepassterEinleittext =  `{Vorname} {Nachname} arbeitete als {Funktion} vom {AngestelltSeit} bis {AngestelltBis} in der SSBL Stiftung für selbstbestimmtes und begleitetes Leben im Bereich {Bereich}, {TeamText}. Das Arbeitspensum betrug {Pensum}%.`;
      }
      else {
        savedEntry.value.angepassterEinleittext =  `{Vorname} {Nachname} arbeitete als {Funktion} vom {AngestelltSeit} in der SSBL Stiftung für selbstbestimmtes und begleitetes Leben im Bereich {Bereich}, {TeamText}. Das Arbeitspensum betrug {Pensum}%.`;
      }
    }
  }

  if(step.value == 4) {
    if(savedEntry.value.zeugnisart != 'arbeitsbestaetigung') {
      zeugnisAiMode.value = 'rechtschreibpruefung';
      zeugnisAiOn.value = true;
      rewriteZeugnis();
    }
    else {
      generateZeugnis();
    }
  }
  else {
    if(
      savedEntry.value.angepassterEinleittext &&
      savedEntry.value.angepassterEinleittext.length > 0 &&
      savedEntry.value.funktion &&
      savedEntry.value.funktion.length > 0 &&
      savedEntry.value.funktion[0].vorlageText &&
      savedEntry.value.abteilung &&
      savedEntry.value.abteilung.length > 0 &&
      savedEntry.value.abteilung[0].vorlageText &&
      savedEntry.value.bereich &&
      savedEntry.value.bereich.length > 0 &&
      savedEntry.value.bereich[0].title &&
      savedEntry.value.team &&
      savedEntry.value.team.length > 0 &&
      savedEntry.value.team[0].title
    ) {
      generateZeugnis();
    }
  }
}

const generateZeugnis = () => {
  loading.value = true;

  let zeugnisText = "";

  zeugnisText += `<p>${savedEntry.value.angepassterEinleittext}</p>`;

  zeugnisText += `<p><abteilungtext>${(savedEntry.value.abteilung && savedEntry.value.abteilung.length > 0) ? savedEntry.value.abteilung[0].vorlageText : ""}</abteilungtext></p>`;


  let tätigkeiten = savedEntry.value.funktion[0].vorlageText.replaceAll(/(^- .{0,}$)+/gm, (tätigkeit) => {
    return `<li>${tätigkeit.replace('- ', '')}</li>`;
  });

  let lines = tätigkeiten.split('\n');
  let lastLineHadLi = false;

  let parsedString = "";

  lines.forEach((line: any) => {
    if(line.startsWith("<li>")) {
      if(!lastLineHadLi) {
        line = "<aufgaben>" + line;
      }
      lastLineHadLi = true;
    }
    else {
      if(lastLineHadLi) {
        line = "</aufgaben>" + line;
      }
      lastLineHadLi = false;
    }
    parsedString += line;
  });

  if(lastLineHadLi) {
    parsedString += "</aufgaben>";
  }


  zeugnisText += `<p>Das Aufgabengebiet von {Vorname} {Nachname} umfasst folgende Tätigkeiten:</p>${parsedString}`;


  categories.value.forEach((category: any) => {
    // check if any of the vorlagen in the category has a rating
    let hasRating = category.vorlagen.some((vorlage: any) => {
      return vorlage.rating > 0;
    });

    if(hasRating) {
      zeugnisText += "<p>";

      category.vorlagen.forEach((vorlage: any) => {
        if(vorlage.text) {
          zeugnisText += `${vorlage.text} `;
        }
      });

      zeugnisText += "</p>";
    }

  });

  let abschlussText = savedEntry.value.andererAbschlussgrund;

  if(savedEntry.value.zeugnisart == "arbeitsbestaetigung") {
    abschlussText = savedEntry.value.abschlussgrund[0].abschlusstextNeutral;
  }

  if(abschlussText) {
    zeugnisText += `<p>${abschlussText}</p>`
  }


  zeugnisText = zeugnisText.replaceAll("{Vorname}", savedEntry.value.vorname);
  zeugnisText = zeugnisText.replaceAll("{Nachname}", savedEntry.value.nachname);
  zeugnisText = zeugnisText.replaceAll("{Geburtsdatum}", formatDate(savedEntry.value.geburtsdatum));

  if(savedEntry.value.heimatort) {
    zeugnisText = zeugnisText.replaceAll("{Heimatort}", savedEntry.value.heimatort);
  }

  zeugnisText = zeugnisText.replaceAll("{AngestelltSeit}", formatDate(savedEntry.value.anstellungSeit));
  zeugnisText = zeugnisText.replaceAll("{AngestelltBis}", formatDate(savedEntry.value.anstellungBis));

  zeugnisText = zeugnisText.replaceAll("{Funktion}", savedEntry.value.funktion[0].funktionBezeichnungText ?? savedEntry.value.funktion[0].title);
  zeugnisText = zeugnisText.replaceAll("{Abteilung}", savedEntry.value.abteilung[0].title);
  zeugnisText = zeugnisText.replaceAll("{Bereich}", savedEntry.value.bereich[0].title);
  zeugnisText = zeugnisText.replaceAll("{Pensum}", savedEntry.value.pensum);

  zeugnisText = zeugnisText.replaceAll("{TeamText}", savedEntry.value.team[0].vorlageText);
  zeugnisText = zeugnisText.replaceAll("{Team}", savedEntry.value.team[0].title);

  zeugnisText = zeugnisText.replaceAll("{Er/Sie} ", savedEntry.value.geschlecht == "m" ? "Er " : "Sie ");
  zeugnisText = zeugnisText.replaceAll(" {er/sie}", savedEntry.value.geschlecht == "m" ? " er" : " sie");
  zeugnisText = zeugnisText.replaceAll(" {ihr/ihm}", savedEntry.value.geschlecht == "m" ? " ihm" : " ihr");

  savedEntry.value.erstelltesZeugnis = zeugnisText;

  loading.value = false;
}

const rewordVorlage = async (vorlage: any) => {
  vorlage.loading = true;
  // get vorlage kategorie
  let vorlageKategorie = categories.value.find((category: any) => {
    return category.vorlagen.includes(vorlage);
  });

  let vorlageText = `<settings>{"bewertung": "${vorlage.rating}/4", "geschlecht": "${savedEntry.value.geschlecht}", "kompetenz": "${ vorlageKategorie.title } - ${ vorlage.title }"}</settings>${vorlage.text}`;

  const response = await axios.post('/actions/ssbl/openai/template', {
    text: vorlageText,
    model: settings.value.model,
    temperature: settings.value.temperature,
    topP: settings.value.topP,
    frequencyPenalty: settings.value.frequencyPenalty,
    presencePenalty: settings.value.presencePenalty,
    systemMessage: settings.value.systemMessageVorlagen,
    exampleMessages: settings.value.beispielCallsVorlagen
  });
  vorlage.loading = false;

  const answer = JSON.parse(response.data.answer);

  if(answer.warning) {
    addAlert(answer.warning);
  }

  return answer.text;
}

const spellcheckVorlage = async (vorlage: any) => {
  vorlage.loading = true;
  // get vorlage kategorie
  let vorlageKategorie = categories.value.find((category: any) => {
    return category.vorlagen.includes(vorlage);
  });

  let vorlageText = `<settings>{"bewertung": "${vorlage.rating}/4", "geschlecht": "${savedEntry.value.geschlecht}", "kompetenz": "${ vorlageKategorie.title } - ${ vorlage.title }"}</settings>${vorlage.text}`;

  const response = await axios.post('/actions/ssbl/openai/template', {
    text: vorlageText,
    model: settings.value.model,
    temperature: settings.value.temperature,
    topP: settings.value.topP,
    frequencyPenalty: settings.value.frequencyPenalty,
    presencePenalty: settings.value.presencePenalty,
    systemMessage: settings.value.systemMessageSpellcheck,
    exampleMessages: settings.value.beispielCallsSpellcheck
  });
  vorlage.loading = false;

  const answer = JSON.parse(response.data.answer);

  if(answer.warning) {
    addAlert(answer.warning);
  }

  return answer.text;
}

const spellcheckZeugnis = async () => {
  loading.value = true;

  let zeitform = (savedEntry.value.zeugnisart == "zwischenzeugnis" || savedEntry.value.zeugnisart == "arbeitsbestaetigung") ? "präsens" : "präteritum";

  let anonymizedZeugnis = `<settings>{"geschlecht": "${savedEntry.value.geschlecht}", "zeitform": "${zeitform}"}</settings>` + (savedEntry.value.erstelltesZeugnis ?? "");

  anonymizedZeugnis = anonymizedZeugnis.replaceAll(savedEntry.value.vorname, "{Vorname}");
  anonymizedZeugnis = anonymizedZeugnis.replaceAll(savedEntry.value.nachname, "{Nachname}");
  anonymizedZeugnis = anonymizedZeugnis.replaceAll(formatDate(savedEntry.value.geburtsdatum), "{Geburtsdatum}");

  if(savedEntry.value.heimatort) {
    anonymizedZeugnis = anonymizedZeugnis.replaceAll(savedEntry.value.heimatort, "{Heimatort}");
  }

  anonymizedZeugnis = anonymizedZeugnis.replaceAll('Er ', "{Er/Sie} ");
  anonymizedZeugnis = anonymizedZeugnis.replaceAll('Sie ', "{Er/Sie} ");
  anonymizedZeugnis = anonymizedZeugnis.replaceAll(' er', " {er/sie}");
  anonymizedZeugnis = anonymizedZeugnis.replaceAll(' sie', " {er/sie}");
  anonymizedZeugnis = anonymizedZeugnis.replaceAll(' ihr', " {ihr/ihm}");
  anonymizedZeugnis = anonymizedZeugnis.replaceAll(' ihm', " {ihr/ihm}");


  // get text between <abteilungtext> and </abteilungtext> and <aufgaben> and </aufgaben>
  let currentAbteilungText = savedEntry.value.erstelltesZeugnis.match(/<abteilungtext>(.*?)<\/abteilungtext>/);
  let currentAufgaben = savedEntry.value.erstelltesZeugnis.match(/<aufgaben>(.*?)<\/aufgaben>/);

  anonymizedZeugnis = anonymizedZeugnis.replace(/<abteilungtext>(.*?)<\/abteilungtext>/, '<abteilungtext></abteilungtext>');
  anonymizedZeugnis = anonymizedZeugnis.replace(/<aufgaben>(.*?)<\/aufgaben>/, '<aufgaben></aufgaben>');
  

  const response = await axios.post('/actions/ssbl/openai/zeugnis', {
    text: anonymizedZeugnis,
    model: settings.value.model,
    temperature: settings.value.temperature,
    topP: settings.value.topP,
    frequencyPenalty: settings.value.frequencyPenalty,
    presencePenalty: settings.value.presencePenalty,
    systemMessage: settings.value.systemMessageZeugnisSpellcheck.replaceAll("{Zeitform}", zeitform),
    exampleMessages: settings.value.beispielCallsZeugnisSpellcheck,
  });

  loading.value = false;

  let aiZeugnis = response.data.answer;

  if(currentAbteilungText) {
    aiZeugnis = aiZeugnis.replace(/<abteilungtext>(.*?)<\/abteilungtext>/, `<abteilungtext>${currentAbteilungText[1]}</abteilungtext>`);
  }
  if(currentAufgaben){
    aiZeugnis = aiZeugnis.replace(/<aufgaben>(.*?)<\/aufgaben>/, `<aufgaben>${currentAufgaben[1]}</aufgaben>`);
  }

  aiZeugnis = aiZeugnis.replaceAll("{Vorname}", savedEntry.value.vorname);
  aiZeugnis = aiZeugnis.replaceAll("{Nachname}", savedEntry.value.nachname);
  aiZeugnis = aiZeugnis.replaceAll("{Geburtsdatum}", formatDate(savedEntry.value.geburtsdatum));

  if(savedEntry.value.heimatort) {
    aiZeugnis = aiZeugnis.replaceAll("{Heimatort}", savedEntry.value.heimatort);
  }

  aiZeugnis = aiZeugnis.replaceAll("{Er/Sie} ", savedEntry.value.geschlecht == "m" ? "Er " : "Sie ");
  aiZeugnis = aiZeugnis.replaceAll(" {er/sie}", savedEntry.value.geschlecht == "m" ? " er" : " sie");
  aiZeugnis = aiZeugnis.replaceAll(" {ihr/ihm}", savedEntry.value.geschlecht == "m" ? " ihr" : " ihm");

  return aiZeugnis;
}


const rewordZeugnis = async () => {
  loading.value = true;
  let zeitform = (savedEntry.value.zeugnisart == "zwischenzeugnis" || savedEntry.value.zeugnisart == "arbeitsbestaetigung")  ? "präsens" : "präteritum";

  let anonymizedZeugnis = `<settings>{"geschlecht": "${savedEntry.value.geschlecht}", "zeitform": "${zeitform}"}</settings>` + (savedEntry.value.erstelltesZeugnis);
  anonymizedZeugnis = anonymizedZeugnis.replaceAll(savedEntry.value.vorname, "{Vorname}");
  anonymizedZeugnis = anonymizedZeugnis.replaceAll(savedEntry.value.nachname, "{Nachname}");
  anonymizedZeugnis = anonymizedZeugnis.replaceAll(formatDate(savedEntry.value.geburtsdatum), "{Geburtsdatum}");

  if(savedEntry.value.heimatort) {
    anonymizedZeugnis = anonymizedZeugnis.replaceAll(savedEntry.value.heimatort, "{Heimatort}");
  }

  anonymizedZeugnis = anonymizedZeugnis.replaceAll('Er ', "{Er/Sie} ");
  anonymizedZeugnis = anonymizedZeugnis.replaceAll('Sie ', "{Er/Sie} ");
  anonymizedZeugnis = anonymizedZeugnis.replaceAll(' er', " {er/sie}");
  anonymizedZeugnis = anonymizedZeugnis.replaceAll(' sie', " {er/sie}");
  anonymizedZeugnis = anonymizedZeugnis.replaceAll(' ihr', " {ihr/ihm}");
  anonymizedZeugnis = anonymizedZeugnis.replaceAll(' ihm', " {ihr/ihm}");

  // get text between <abteilungtext> and </abteilungtext> and <aufgaben> and </aufgaben>
  let currentAbteilungText = savedEntry.value.erstelltesZeugnis.match(/<abteilungtext>([^]*?)<\/abteilungtext>/);
  let currentAufgaben = savedEntry.value.erstelltesZeugnis.match(/<aufgaben>([^]*?)<\/aufgaben>/);

  anonymizedZeugnis = anonymizedZeugnis.replace(/<abteilungtext>([^]*?)<\/abteilungtext>/, '<abteilungtext></abteilungtext>');
  anonymizedZeugnis = anonymizedZeugnis.replace(/<aufgaben>([^]*?)<\/aufgaben>/, '<aufgaben></aufgaben>');
  
  const response = await axios.post('/actions/ssbl/openai/zeugnis', {
    text: anonymizedZeugnis,
    model: settings.value.model,
    temperature: settings.value.temperature,
    topP: settings.value.topP,
    frequencyPenalty: settings.value.frequencyPenalty,
    presencePenalty: settings.value.presencePenalty,
    systemMessage: settings.value.systemMessageZeugnis.replaceAll("{Zeitform}", zeitform),
    exampleMessages: settings.value.beispielCallsZeugnis,
  });

  loading.value = false;

  let aiZeugnis = response.data.answer;

  if(currentAbteilungText) {
    aiZeugnis = aiZeugnis.replace(/<abteilungtext>(.*?)<\/abteilungtext>/, `<abteilungtext>${currentAbteilungText[1]}</abteilungtext>`);
  }
  if(currentAufgaben){
    aiZeugnis = aiZeugnis.replace(/<aufgaben>(.*?)<\/aufgaben>/, `<aufgaben>${currentAufgaben[1]}</aufgaben>`);
  }

  aiZeugnis = aiZeugnis.replaceAll("{Vorname}", savedEntry.value.vorname);
  aiZeugnis = aiZeugnis.replaceAll("{Nachname}", savedEntry.value.nachname);
  aiZeugnis = aiZeugnis.replaceAll("{Geburtsdatum}", formatDate(savedEntry.value.geburtsdatum));

  if(savedEntry.value.heimatort) {
    aiZeugnis = aiZeugnis.replaceAll("{Heimatort}", savedEntry.value.heimatort);
  }

  aiZeugnis = aiZeugnis.replaceAll("{Er/Sie} ", savedEntry.value.geschlecht == "m" ? "Er " : "Sie ");
  aiZeugnis = aiZeugnis.replaceAll(" {er/sie}", savedEntry.value.geschlecht == "m" ? " er" : " sie");
  aiZeugnis = aiZeugnis.replaceAll(" {ihr/ihm}", savedEntry.value.geschlecht == "m" ? " ihr" : " ihm");

  return aiZeugnis;
}

const savePageData = () => {
  let { gespeicherteOptionen, sortOrder } = createGespeicherteOptionen();
  let { nachrichten, nachrichtenSortOrder } = createNachrichten();

  if(!checkDisabledCurrentPage(step.value)) {
    return axios.post(graphqlUrl, {
        query: ZeugnisMutation,
        variables: {
          id: savedEntry.value.id,
          vorname: savedEntry.value.vorname,
          nachname: savedEntry.value.nachname,
          "gespeicherteOptionen": gespeicherteOptionen,
          "sortOrder": sortOrder,
          freierText: savedEntry.value.freierText,
          erstelltesZeugnis: savedEntry.value.erstelltesZeugnis,
          heimatort: savedEntry.value.heimatort,
          pensum: savedEntry.value.pensum,
          geburtsdatum: savedEntry.value.geburtsdatum,
          anstellungSeit: savedEntry.value.anstellungSeit,
          anstellungBis: savedEntry.value.anstellungBis,
          vorgesetzter: savedEntry.value.vorgesetzter[0] ? [Number(savedEntry.value.vorgesetzter[0].id)] : [],
          hoehererVorgesetzter: savedEntry.value.hoehererVorgesetzter[0] ? [Number(savedEntry.value.hoehererVorgesetzter[0].id)] : [],
          aktuellerSchritt: stepToSave.value ? stepToSave.value : savedEntry.value.aktuellerSchritt,
          hrVerantwortlicher: savedEntry.value.hrVerantwortlicher[0] ? [Number(savedEntry.value.hrVerantwortlicher[0].id) ] : [currentUser.id],
          funktion: savedEntry.value.funktion[0] ? [Number(savedEntry.value.funktion[0].id) ] : [],
          bereich: savedEntry.value.bereich[0] ? [Number(savedEntry.value.bereich[0].id) ] : [],
          abteilung: savedEntry.value.abteilung[0] ? [Number(savedEntry.value.abteilung[0].id) ] : [],
          team: savedEntry.value.team[0] ? [Number(savedEntry.value.team[0].id) ] : [],
          abschlussgrund: savedEntry.value.abschlussgrund[0] ? [Number(savedEntry.value.abschlussgrund[0].id) ] : [],
          andererAbschlussgrund: savedEntry.value.andererAbschlussgrund,
          authorId: currentUser.id,
          geschlecht: savedEntry.value.geschlecht,
          nachrichten: nachrichten,
          nachrichtenSortOrder: nachrichtenSortOrder,
          zeugnisart: savedEntry.value.zeugnisart,
          angepassterEinleittext: savedEntry.value.angepassterEinleittext
        }
      }, {
        headers: {
          'Authorization': "Bearer " + gqlToken
        }
      }
    ).then((response) => {
      let zeugnisEintrag = response.data.data.save_zeugnisse_zeugnis_Entry;
      zeugnisEintrag.geburtsdatum = zeugnisEintrag.geburtsdatum ? zeugnisEintrag.geburtsdatum.split('T')[0] : "";
      zeugnisEintrag.anstellungSeit = zeugnisEintrag.anstellungSeit ? zeugnisEintrag.anstellungSeit.split('T')[0] : "";
      zeugnisEintrag.anstellungBis = zeugnisEintrag.anstellungBis ? zeugnisEintrag.anstellungBis.split('T')[0] : "";
      savedEntry.value = zeugnisEintrag;

      getVorlagen();
      if(savedEntry.value.nachrichten.length > 0 && savedEntry.value.nachrichten[savedEntry.value.nachrichten.length - 1].zugewiesenePerson[0].id != currentUser.id) {
        addAlert("Du kannst aktuell nichts bearbeiten, weil du nicht zugewiesen sind.");
      }

      /* Update the vorlagen with the saved data */
      savedEntry.value.gespeicherteOptionen.forEach((option: any) => {

        let foundVorlage: any = null;
        let tempVorlage = null;

        categories.value.forEach((category: any) => {
          tempVorlage = category.vorlagen.find((vorlage: any) => {
            return option.vorlageEintrag.length > 0 && vorlage.id === option.vorlageEintrag[0].id;
          });

          if(tempVorlage) {
            foundVorlage = tempVorlage;
          }
        });

        if(foundVorlage) {
          foundVorlage.rating = LEISTUNGSSTUFEN.indexOf(option.gewaehlteOption) + 1;
          foundVorlage.text = option.vorlageText;
          foundVorlage.aiGenerationMode = option.aiGenerationMode;

          if(option.aiGenerationMode == "rechtschreibpruefung") {
            foundVorlage.aiTexts.push(option.vorlageText);
            foundVorlage.currentAiTextIndex = foundVorlage.aiTexts.length - 1;
          }
          
          if(option.aiGenerationMode == "ki") {
            foundVorlage.aiTexts.push(option.vorlageText);
            foundVorlage.currentAiTextIndex = foundVorlage.aiTexts.length - 1;
          }
        }
      });

      categories.value.push({
        title: "Abschlusstext",
        id: "abschlussText",
        vorlagen: [],
      });
    }).catch((error) => {
      console.log(error);
    });
  }
  else {
    return null;
  }
}

const getSavedEntry = () => {
  axios.post(graphqlUrl, {
        query: ZeugnisQuery,
        variables: {
          id: id
        }
      }, {
        headers: {
          'Authorization': "Bearer " + gqlToken
        }
      }
  ).then((response) => {
    let zeugnis = response.data.data.zeugnisseEntries[0];

    zeugnis.geburtsdatum = zeugnis.geburtsdatum ? zeugnis.geburtsdatum.split('T')[0] : "";
    zeugnis.anstellungSeit = zeugnis.anstellungSeit ? zeugnis.anstellungSeit.split('T')[0] : "";
    zeugnis.anstellungBis = zeugnis.anstellungBis ? zeugnis.anstellungBis.split('T')[0] : "";

    savedEntry.value = zeugnis;

    getVorlagen();

    if(savedEntry.value.nachrichten.length > 0 && savedEntry.value.nachrichten[savedEntry.value.nachrichten.length - 1].zugewiesenePerson[0].id != currentUser.id) {
      addAlert("Du kannst aktuell nichts bearbeiten, weil du nicht zugewiesen bist.");
    }

    /* Update the vorlagen with the saved data */
    savedEntry.value.gespeicherteOptionen.forEach((option: any) => {

      let foundVorlage: any = null;
      let tempVorlage = null;

      categories.value.forEach((category: any) => {
        tempVorlage = category.vorlagen.find((vorlage: any) => {
          return option.vorlageEintrag.length > 0 && vorlage.id === option.vorlageEintrag[0].id;
        });

        if(tempVorlage) {
          foundVorlage = tempVorlage;
        }
      });


      if(foundVorlage) {
        foundVorlage.rating = LEISTUNGSSTUFEN.indexOf(option.gewaehlteOption) + 1;
        foundVorlage.text = option.vorlageText;
        foundVorlage.aiGenerationMode = option.aiGenerationMode;

        if(option.aiGenerationMode == "rechtschreibpruefung") {
          foundVorlage.aiTexts.push(option.vorlageText);
          foundVorlage.currentAiTextIndex = foundVorlage.aiTexts.length - 1;
        }
        
        if(option.aiGenerationMode == "ki") {
          foundVorlage.aiTexts.push(option.vorlageText);
          foundVorlage.currentAiTextIndex = foundVorlage.aiTexts.length - 1;
        }
      }
    });

    categories.value.push({
      title: "Abschlusstext",
      id: "abschlussText",
      vorlagen: [],
    });

    step.value = textToStep[savedEntry.value.aktuellerSchritt];

  }).catch((error) => {
    console.log(error);
  });
}

const createGespeicherteOptionen = () => {
  let gespeicherteOptionen: any = [];
  let sortOrder: any= [];

  categories.value.forEach((currentCategory: any) => {

    currentCategory.vorlagen.forEach((vorlage: any, index: number) => {

      let foundOption: any = savedEntry.value.gespeicherteOptionen.find((option: any) => {
        return option.vorlageEintrag[0].id === vorlage.id;
      });

      if(vorlage.rating != 0) {

        let id: any = vorlage.id;

        if(foundOption) {
          id = foundOption.vorlageEintrag[0].id;
          sortOrder.push(id);

          gespeicherteOptionen.push({
            "gespeicherteOptionen":
              {
                id: id,
                gewaehlteOption: LEISTUNGSSTUFEN[vorlage.rating - 1],
                vorlageText: vorlage.text,
                aiGenerationMode: vorlage.aiGenerationMode,
                vorlageEintrag: Number(vorlage.id),
              }
          });
        }
        else {
          id = 'new' + index;
          sortOrder.push(id);

          gespeicherteOptionen.push({
          "gespeicherteOptionen":
            {
              id: id,
              gewaehlteOption: LEISTUNGSSTUFEN[vorlage.rating - 1],
              vorlageText: vorlage.text,
              aiGenerationMode: vorlage.aiGenerationMode,
              vorlageEintrag: Number(vorlage.id),
            }
          });
        }
      }
    });
  });

  return {gespeicherteOptionen, sortOrder};
}

const createNachrichten = () => {
  let nachrichten: any = [];
  let nachrichtenSortOrder: any= [];

  savedEntry.value.nachrichten.forEach((nachricht: any, index: number) => {

    let id: any = nachricht.id;

    nachrichtenSortOrder.push(id);

    nachrichten.push({
      "nachricht":
        {
          id: id,
          nachrichtText: nachricht.nachrichtText,
          datum: nachricht.datum,
          autor: nachricht.autor[0] ? [Number(nachricht.autor[0].id)] : [],
          zugewiesenePerson: nachricht.zugewiesenePerson[0] ? [Number(nachricht.zugewiesenePerson[0].id)] : [],
          aktuellerSchritt: nachricht.aktuellerSchritt,
        }
    });
  });


  if(createNachricht.value) {


    const today = new Date();

    let nachrichtenLength = savedEntry.value.nachrichten.length;

    if(zeugnisAiMode.value != "template") {
      const newIdAI = 'new' + nachrichtenLength;
      nachrichtenLength++;
      nachrichtenSortOrder.push(newIdAI);

      let nachrichtText = "";

      if(zeugnisAiMode.value == "ki") {
        nachrichtText = "hat das Zeugnis mit KI überarbeitet.";
      }
      else if(zeugnisAiMode.value == "rechtschreibpruefung") {
        nachrichtText = "hat das Zeugnis mit KI auf Rechtschreibfehler überprüft.";
      }

      nachrichten.push({
        "nachricht":
        {
          id: newIdAI,
          nachrichtText: nachrichtText,
          datum: today.toISOString(),
          autor: [Number(currentUser.id)],
          zugewiesenePerson: [Number(currentUser.id)],
          aktuellerSchritt: stepToSave.value ? stepToSave.value : savedEntry.value.aktuellerSchritt,
        }
      });
    }

    const newId = 'new' + nachrichtenLength;
    nachrichtenSortOrder.push(newId);

    nachrichten.push({
      "nachricht":
      {
        id: newId,
        nachrichtText: nachrichtField.value,
        datum: today.toISOString(),
        autor: [Number(currentUser.id)],
        zugewiesenePerson: [Number(zugewiesenePerson.value)],
        aktuellerSchritt: stepToSave.value ? stepToSave.value : savedEntry.value.aktuellerSchritt,
      }
    });

    createNachricht.value = false;
  }
 
  return {nachrichten, nachrichtenSortOrder};
}

const nextAIText = (vorlage: any) => {
  if(vorlage.currentAiTextIndex < vorlage.aiTexts.length - 1) {
    vorlage.currentAiTextIndex++;
    vorlage.text = vorlage.aiTexts[vorlage.currentAiTextIndex];
  }
}

const previousAIText = (vorlage: any) => {
  if(vorlage.currentAiTextIndex > 0) {
    vorlage.currentAiTextIndex--;
    vorlage.text = vorlage.aiTexts[vorlage.currentAiTextIndex];
  }
}

const regenerateAIText = async (vorlage: any) => {
  let rewordedVorlage = await rewordVorlage(vorlage);
  vorlage.aiTexts.push(rewordedVorlage);
  vorlage.currentAiTextIndex = vorlage.aiTexts.length - 1;

  vorlage.text = rewordedVorlage;
}

const rewriteZeugnis = async () => {
  if(zeugnisAiMode.value == 'ki') {
    let rewordedZeugnis: string = await rewordZeugnis();

    rewordedZeugnis = rewordedZeugnis.replace(/(?:\r\n|\r|\n)/g, ' ');

    let rewordedZeugnisObject = JSON.parse(rewordedZeugnis);
    if(rewordedZeugnisObject.warning) {
      addAlert(rewordedZeugnisObject.warning);
    }
    let rewordedZeugnisText = rewordedZeugnisObject.text;

    zeugnisAiTexts.value.push(rewordedZeugnisText);
    currentZeugnisAiTextIndex.value = zeugnisAiTexts.value.length - 1;

    savedEntry.value.erstelltesZeugnis = rewordedZeugnisText;
  }
  else if(zeugnisAiMode.value == 'rechtschreibpruefung') {
    let spellcheckedZeugnis = await spellcheckZeugnis();

    let spellcheckedZeugnisObject = JSON.parse(spellcheckedZeugnis);
    
    if(spellcheckedZeugnisObject.warning) {
      addAlert(spellcheckedZeugnisObject.warning);
    }

    savedEntry.value.erstelltesZeugnis = spellcheckedZeugnisObject.text;
  }
  else {
    generateZeugnis();
  }
}

const nextZeugnisAIText = () => {
  if(currentZeugnisAiTextIndex.value < zeugnisAiTexts.value.length - 1) {
    currentZeugnisAiTextIndex.value++;
    savedEntry.value.erstelltesZeugnis = zeugnisAiTexts.value[currentZeugnisAiTextIndex.value];
  }
}

const previousZeugnisAIText = () => {
  if(currentZeugnisAiTextIndex.value > 0) {
    currentZeugnisAiTextIndex.value--;
    savedEntry.value.erstelltesZeugnis = zeugnisAiTexts.value[currentZeugnisAiTextIndex.value];
  }
}

const switchStep = (index: number) => {

  navTab.value = null;
  let previousStep = step.value;

  if(index == 2  && savedEntry.value.aktuellerSchritt == 'bewertung') {
    stepToSave.value = "ueberpruefungDurchVg1";
  }

  if(previousStep != index) {


      
    if(index == 2 && (!savedEntry.value.erstelltesZeugnis || savedEntry.value.aktuellerSchritt == 'bewertung' || savedEntry.value.aktuellerSchritt == 'ueberpruefungDurchVg1') && (currentUser.id == savedEntry.value.vorgesetzter[0].id || currentUser.admin)) {
      generateZeugnis();
    }

    savePageData()?.then(() => {
      if(!window.location.pathname.includes('zeugnis')) {
        window.history.pushState({}, '', '/zeugnis/' + savedEntry.value.uid);     
      }
    });
  }

  step.value = index;
}

const switchCategory = (index: number) => {
  navTab.value = null;
  activeCategoryIndex.value = index;

  if(categories.value[activeCategoryIndex.value].title == "Abschlusstext" && (savedEntry.value.andererAbschlussgrund == "" || savedEntry.value.andererAbschlussgrund == null)) {
    savedEntry.value.andererAbschlussgrund = savedEntry.value.abschlussgrund[0].abschlusstextPositiv;
  }
}

const checkDisabled = (index: number) => {
  let disabled = false;

  switch (index) {
    case 0:
      disabled = false;
      break;
    case 1:
      disabled = savedEntry.value.vorname == "" ||
      savedEntry.value.nachname == "" ||
      savedEntry.value.pensum == ""  ||
      savedEntry.value.geburtsdatum == "" ||
      savedEntry.value.vorgesetzter.length == 0 ||
      savedEntry.value.hoehererVorgesetzter.length == 0 ||
      savedEntry.value.hrVerantwortlicher.length == 0 ||
      savedEntry.value.funktion.length == 0 ||
      savedEntry.value.bereich.length == 0 ||
      savedEntry.value.abteilung.length == 0 ||
      savedEntry.value.team.length == 0 ||
      savedEntry.value.abschlussgrund.length == 0 ||
      savedEntry.value.geschlecht == "" || 
      savedEntry.value.aktuellerSchritt == "personalienAngeben";
      break;
    case 2:
      // if(categories.value.length > 0) {
      //   categories.value[activeCategoryIndex.value].vorlagen.forEach((vorlage: any) => {
      //     if(vorlage.rating == 0) {
      //       disabled = true;
      //     }
      //   });
      // }
      // else {
      //   disabled = true;
      // }

      break;
    case 3:
    case 4:
    case 5:
      disabled = !savedEntry.value.erstelltesZeugnis;
      break;
    case 6:
      disabled = savedEntry.value.aktuellerSchritt != "abgeschlossen";
      break;
    default:
      disabled = savedEntry.value.vorname == "" ||
        savedEntry.value.nachname == "" ||
        savedEntry.value.pensum == ""  ||
        savedEntry.value.geburtsdatum == "" ||
        savedEntry.value.vorgesetzter.length == 0 ||
        savedEntry.value.hoehererVorgesetzter.length == 0 ||
        savedEntry.value.hrVerantwortlicher.length == 0 ||
        savedEntry.value.funktion.length == 0 ||
        savedEntry.value.bereich.length == 0 ||
        savedEntry.value.abteilung.length == 0 ||
        savedEntry.value.team.length == 0 ||
        savedEntry.value.abschlussgrund.length == 0 ||
        savedEntry.value.geschlecht == "";
      break;
  }

  return disabled;
}

const checkDisabledCurrentPage = (index: number) => {
  let disabled = false;

  switch (index) {
    case 0:
      disabled = (savedEntry.value.aktuellerSchritt != "personalienAngeben" && savedEntry.value.aktuellerSchritt != "");
      break;
    case 1:
      disabled = ((savedEntry.value.aktuellerSchritt != "bewertung" && savedEntry.value.aktuellerSchritt != "ueberpruefungDurchVg1") || savedEntry.value.vorgesetzter[0].id != currentUser.id);
      break;
    case 2:
      disabled = (savedEntry.value.aktuellerSchritt != "ueberpruefungDurchVg1" || savedEntry.value.vorgesetzter[0].id != currentUser.id);
      break;
    case 3:
      disabled = (savedEntry.value.aktuellerSchritt != "ueberpruefungDurchVg2" || savedEntry.value.hoehererVorgesetzter[0].id != currentUser.id);
      break;
    case 4:
      disabled = ((savedEntry.value.aktuellerSchritt != "ueberpruefungDurchHr") || savedEntry.value.hrVerantwortlicher[0].id != currentUser.id);
      break;
    case 5:
      disabled = ((savedEntry.value.aktuellerSchritt != "zurUnterschrift" && savedEntry.value.aktuellerSchritt != "abgeschlossen") || savedEntry.value.hrVerantwortlicher[0].id != currentUser.id);
      break;
  }

  return disabled && currentUser.admin == false;
}

const formatDate = (date: string) => {
  let d = new Date(date);

  let month = ('0' + (d.getMonth() + 1)).slice(-2);
  let day = ('0' + d.getDate()).slice(-2);
  let year = d.getFullYear();

  return `${day}.${month}.${year}`;
}

const formatDateForDocument = (date: string) => {
  let d = new Date(date);

  let month = ('0' + (d.getMonth() + 1)).slice(-2);
  let day = ('0' + d.getDate()).slice(-2);
  let year = d.getFullYear();

  return `${day}.${month}.${year}`;
}

const formatDateTime = (date: string) => {
  let d = new Date(date);

  let month = '' + (d.getMonth() + 1);
  let day = '' + d.getDate();
  let year = d.getFullYear();

  let hour = ("0" + d.getHours()).slice(-2);
  let minute = ("0" + d.getMinutes()).slice(-2);

  return `${day}.${month}.${year} ${hour}:${minute}`;
}

const downloadWord = () => {

  loadingWord.value = true;
  loading.value = true;

  savePageData();

  const text = savedEntry.value.erstelltesZeugnis.replace("<abteilungtext>", "").replace("</abteilungtext>", "")
  .replace("<aufgaben>", "<ul>").replace("</aufgaben>", "</ul>").replace("<fixzeit>", "").replace("</fixzeit>", "");

  let textBlocks = transformHTMLToBlocks(text);

  axios.post(generatorUrl + 'docx', {
      vorname: savedEntry.value.vorname,
      nachname: savedEntry.value.nachname,
      text: text,
      textBlocks: textBlocks,
      geburtsdatum: formatDateForDocument(savedEntry.value.geburtsdatum),
      heimatort: savedEntry.value.heimatort,
      zeugnisart: zeugnisarten[savedEntry.value.zeugnisart],
      anstellungSeit: savedEntry.value.anstellungSeit,
      anstellungBis: savedEntry.value.anstellungBis,
      geschlecht: savedEntry.value.geschlecht,
      abteilung: savedEntry.value.abteilung[0].title,
      bereich: savedEntry.value.bereich[0].title,
      funktion: savedEntry.value.funktion[0].funktionBezeichnungText ?? savedEntry.value.funktion[0].title,
      team: savedEntry.value.team[0].title,
      pensum: savedEntry.value.pensum,
      vorgesetzter: savedEntry.value.vorgesetzter[0].fullName,
      hoehererVorgesetzter: savedEntry.value.hoehererVorgesetzter[0].fullName,
      hrVerantwortlicher: savedEntry.value.hrVerantwortlicher[0].fullName,
      bezeichnungHoehererVorgesetzter: savedEntry.value.vorgesetzter[0].bezeichnung ?? "Vorgesetzter",
      bezeichnungHrVerantwortlicher: savedEntry.value.hrVerantwortlicher[0].bezeichnung ?? "HR Business Partner",
      abschlussgrund: savedEntry.value.abschlussgrund[0].title,
      date: formatDateForDocument(new Date()),
      headerText: headerText,
      entwurf: savedEntry.value.aktuellerSchritt != "ueberpruefungDurchHr" && savedEntry.value.aktuellerSchritt != "abgeschlossen",
    }, {
      responseType: 'blob', // important
    }
  ).then((response) => {
      // create file link in browser's memory
      const href = URL.createObjectURL(response.data);

      // create "a" HTML element with href to file & click
      const link = document.createElement('a');
      link.href = href;
      link.setAttribute('download', 'Arbeitszeugnis.docx'); //or any other extension
      document.body.appendChild(link);
      link.click();

      // clean up "a" element & remove ObjectURL
      document.body.removeChild(link);
      URL.revokeObjectURL(href);

      // if(step.value == 4) {
      //   showOverlay.value = true;
      // }
  })
  .finally(() => {
    loadingWord.value = false;
    loading.value = false;
  });

}

const downloadPDF = () => {
  loadingPDF.value = true;
  loading.value = true;

  savePageData();

  const text = savedEntry.value.erstelltesZeugnis.replace("<abteilungtext>", "").replace("</abteilungtext>", "")
    .replace("<aufgaben>", "<ul>").replace("</aufgaben>", "</ul>").replace("<fixzeit>", "").replace("</fixzeit>", "");

  let textBlocks = transformHTMLToBlocks(text);

  axios.post(generatorUrl + 'pdf', {
      vorname: savedEntry.value.vorname,
      nachname: savedEntry.value.nachname,
      text: text,
      textBlocks: textBlocks,
      geburtsdatum: formatDateForDocument(savedEntry.value.geburtsdatum),
      heimatort: savedEntry.value.heimatort,
      zeugnisart: zeugnisarten[savedEntry.value.zeugnisart],
      anstellungSeit: savedEntry.value.anstellungSeit,
      anstellungBis: savedEntry.value.anstellungBis,
      geschlecht: savedEntry.value.geschlecht,
      abteilung: savedEntry.value.abteilung[0].title,
      bereich: savedEntry.value.bereich[0].title,
      funktion: savedEntry.value.funktion[0].funktionBezeichnungText ?? savedEntry.value.funktion[0].title,
      team: savedEntry.value.team[0].title,
      pensum: savedEntry.value.pensum,
      vorgesetzter: savedEntry.value.vorgesetzter[0].fullName,
      hoehererVorgesetzter: savedEntry.value.hoehererVorgesetzter[0].fullName,
      hrVerantwortlicher: savedEntry.value.hrVerantwortlicher[0].fullName,
      bezeichnungHoehererVorgesetzter: savedEntry.value.vorgesetzter[0].bezeichnung ?? "Vorgesetzter",
      bezeichnungHrVerantwortlicher: savedEntry.value.hrVerantwortlicher[0].bezeichnung ?? "HR Business Partner",
      abschlussgrund: savedEntry.value.abschlussgrund[0].title,
      date: formatDateForDocument(new Date()),
      headerText: headerText,
      entwurf: savedEntry.value.aktuellerSchritt != "ueberpruefungDurchHr" && savedEntry.value.aktuellerSchritt != "abgeschlossen",
    }, {
      responseType: 'blob', // important
    }
  ).then((response) => {
      // create file link in browser's memory
      const href = URL.createObjectURL(response.data);

      // create "a" HTML element with href to file & click
      const link = document.createElement('a');
      link.href = href;
      link.setAttribute('download', 'Arbeitszeugnis.pdf'); //or any other extension
      document.body.appendChild(link);
      link.click();

      // clean up "a" element & remove ObjectURL
      document.body.removeChild(link);
      URL.revokeObjectURL(href);

      // if(step.value == 4) {
      //   showOverlay.value = true;
      // }
  })
  .finally(() => {
    loadingPDF.value = false;
    loading.value = false;
  });

}

const sendToVorgesetzter = () => {

  if(checkPersonalien()){
    stepToSave.value = "bewertung";
    createNachricht.value = true;
    zugewiesenePerson.value = savedEntry.value.vorgesetzter[0].id;

    savePageData()?.then(() => {
      if(!window.location.pathname.includes('zeugnis')) {
        window.history.pushState({}, '', '/zeugnis/' + savedEntry.value.uid);
      }

      let message = `<p>Liebe Vorgesetzte, Lieber Vorgesetzter</p>

        <p>Für die Erstellung des Arbeitszeugnisses bitten wir Dich, die Beurteilung im Zeugnisgenerator baldmöglichst auszufüllen. Deine Aufgabe besteht darin, die Leistungen des Mitarbeitenden anhand der folgenden Bewertungsskala einzuschätzen:</p>

        <ul>
          <li>⭐️ – genügende Leistung</li>
          <li>⭐️⭐️ – gute Leistung</li>
          <li>⭐️⭐️⭐️ – hervorragende Leistung</li>
        </ul>

        <p>Falls Du zu einem bestimmten Punkt keine Stellung beziehen möchtest, kannst Du das Feld einfach freilassen.</p>

        <p>Über den Schieber hast Du die Möglichkeit, die Rechtschreibprüfung oder die KI-Textgenerierung zu aktivieren, falls Du Text ergänzen oder überarbeiten möchtest. Nachdem Du die Beurteilung vollständig ausgefüllt hast, klicke auf <strong>"Weiter"</strong>, um den ersten Entwurf zu sehen. Diesen kannst Du anschliessend an den zweiten Vorgesetzten zur Durchsicht weiterleiten.</p>

        <p>Der Lesefluss und die finale Textkorrektur erfolgen durch das HR.</p>

        <p>Bei Fragen oder Unklarheiten melde Dich gerne bei uns.</p>

        <p>Besten Dank für Deine Unterstützung und freundliche Grüsse</p>`;

      if(nachrichtField.value) {
        message = message + `<p>Nachricht von ${ currentUser.fullName }: ${nachrichtField.value}</p>`;
      }

      sendEmailNotification(
        savedEntry.value.vorgesetzter[0].email,
        "Neues Arbeitszeugnis zum Beurteilen - " + savedEntry.value.vorname + " " + savedEntry.value.nachname,
        message
      )
      .then(() => {
        // addAlert("Das Zeugnis wurde erfolgreich gespeichert und eine Benachrichtigung an den Vorgesetzten gesendet.", "success");
        showSentOverlay("Das Zeugnis wurde erfolgreich gespeichert und eine Benachrichtigung an den Vorgesetzten gesendet.");
      }).catch((error) => {
        console.log(error);
        addAlert("Das Zeugnis konnte nicht an den Vorgesetzten gesendet werden.", "error");
      });
    });
  }
}

const checkPersonalien = () => {
  errors.value = {};
  let isValid = true;

  const stringsToCheck = ["zeugnisart", "vorname", "nachname", "geschlecht", "geburtsdatum", "anstellungSeit", "pensum"];
  const arraysToCheck = ["vorgesetzter", "hoehererVorgesetzter", "hrVerantwortlicher", "funktion", "bereich", "abteilung", "team", "abschlussgrund"];

  stringsToCheck.forEach((string: String) => {
    if(savedEntry.value[string] == "") {
      isValid = false;
      errors.value[string] = "Hoppla, hier fehlt noch eine korrekte Eingabe"
    }
  });

  arraysToCheck.forEach((array: String) => {
    if(savedEntry.value[array].length == 0) {
      isValid = false;
      errors.value[array] = "Hoppla, hier fehlt noch eine korrekte Eingabe"
    }
  });

  if(!isValid) {
    addAlert("Bitte fülle alle erforderlichen Felder aus.", "error");
  }

  return isValid;
}

const sendToNächsterVorgesetzter = () => {
  stepToSave.value = "ueberpruefungDurchVg2";
  createNachricht.value = true;

  zugewiesenePerson.value = savedEntry.value.hoehererVorgesetzter[0].id;

  let message = `<p>Liebe Vorgesetzte, Lieber Vorgesetzter,</p>

      <p>Ein neues Zeugnis wurde Dir zur Überprüfung zugewiesen. Bitte überprüfe den Entwurf und gib dein Feedback dazu ab.</p>

      <p>Falls Du Anmerkungen oder Änderungswünsche hast, kannst Du diese direkt im Zeugnisgenerator vermerken. Nutze dabei die Funktionen <strong>Rechtschreibprüfung</strong> oder <strong>KI-Textgenerierung</strong>, um den Text zu ergänzen oder zu überarbeiten.</p>

      <p>Falls Du das Zeugnis <strong>an den VG1 zurückweisen möchtest</strong>, fülle bitte eine entsprechende Nachricht aus und sende das Zeugnis mit dem Button <strong>"Zurück an VG1"</strong> zurück.</p>

      <p>Wenn das Zeugnis <strong>für die nächste Stufe bereit ist</strong>, klicke bitte auf <strong>"Weiter an HR"</strong>, um es dem HR zur finalen Bearbeitung zukommen zu lassen. Der Lesefluss wird am Schluss durch das HR sichergestellt.</p>

      <p>Bei Fragen oder Unklarheiten melde Dich gerne bei uns.</p><br />

      <p>Besten Dank für Deine Unterstützung und freundliche Grüsse</p>`;

  if(nachrichtField.value) {
    message = message + `<p>Nachricht von ${ currentUser.fullName }: ${nachrichtField.value}</p>`;
  }

  savePageData()?.then(() => {
    sendEmailNotification(
      savedEntry.value.hoehererVorgesetzter[0].email,
      "Neues Arbeitszeugnis zum überprüfen - " + savedEntry.value.vorname + " " + savedEntry.value.nachname,
      message
    )
    .then(() => {
      // addAlert("Das Zeugnis wurde erfolgreich gespeichert und eine Benachrichtigung an den Vorgesetzten gesendet.", "success");
      showSentOverlay("Das Zeugnis wurde erfolgreich gespeichert und eine Benachrichtigung an den Vorgesetzten gesendet.");

    }).catch((error) => {
      console.log(error);
      addAlert("Das Zeugnis konnte nicht an den Vorgesetzten gesendet werden.", "error");
    });
  });
}


const sendBackToHR = () => {
  if(nachrichtField.value == "") {
    addAlert("Bitte gib eine Nachricht ein.");
    return;
  }

  stepToSave.value = "personalienAngeben";
  createNachricht.value = true;

  zugewiesenePerson.value = savedEntry.value.hrVerantwortlicher[0].id;

  savePageData()?.then(() => {
    sendEmailNotification(
      savedEntry.value.hrVerantwortlicher[0].email,
      "Zeugnis zurückgewiesen - " + savedEntry.value.vorname + " " + savedEntry.value.nachname,
      `Ein Zeugnis wurde an dich zurückgewiesen. Nachricht von ${ currentUser.fullName }: ${nachrichtField.value}`
    )
    .then(() => {
      // addAlert("Das Zeugnis wurde erfolgreich gespeichert und eine Benachrichtigung an's HR gesendet.", "success");
      showSentOverlay("Das Zeugnis wurde erfolgreich gespeichert und eine Benachrichtigung an's HR gesendet.");

    }).catch((error) => {
      console.log(error);
      addAlert("Das Zeugnis konnte nicht an's HR gesendet werden.", "error");
    });
  });
}



const sendToHRBP = () => {
  stepToSave.value = "ueberpruefungDurchHr";
  createNachricht.value = true;

  zugewiesenePerson.value = savedEntry.value.hrVerantwortlicher[0].id;

  savePageData()?.then(() => {
    sendEmailNotification(
      savedEntry.value.hrVerantwortlicher[0].email,
      "SSBL Zeugnisgenerator: Neues Zeugnis zur Überprüfung - " + savedEntry.value.vorname + " " + savedEntry.value.nachname,
      `Ein neues Zeugnis wurde zur Überprüfung zugewiesen. Bitte überprüfe das Zeugnis und gib dein Feedback ab. Nachricht von ${ currentUser.fullName }: ${nachrichtField.value}`
    )
    .then(() => {
      // addAlert("Das Zeugnis wurde erfolgreich gespeichert und eine Benachrichtigung an's HR gesendet.", "success");
      showSentOverlay("Das Zeugnis wurde erfolgreich gespeichert und eine Benachrichtigung an's HR gesendet.");

    }).catch((error) => {
      console.log(error);
      addAlert("Das Zeugnis konnte nicht an's HR gesendet werden.", "error");
    });
  });
}

const giveToUnterschrift = () => {
  stepToSave.value = "zurUnterschrift";

  savePageData()?.then(() => {
    addAlert("Das Zeugnis wurde zur Unterschrift gegeben.", "success");
  }).catch((error) => {
    console.log(error);
    addAlert("Das Zeugnis konnte nicht gespeichert werden.", "error");
  });
}

const abschliessen = () => {
  stepToSave.value = "abgeschlossen";

  savePageData()?.then(() => {
    addAlert("Hurra, das Zeugnis wurde erfolgreich abgeschlossen.", "success");
  }).catch((error) => {
    console.log(error);
    addAlert("Das Zeugnis konnte nicht abgeschlossen werden.", "error");
  });
}

const generateArbeitsbestätigung = () => {
  if(checkPersonalien()){
    stepToSave.value = "ueberpruefungDurchHr";
  
    createNachricht.value = true;
    zugewiesenePerson.value = savedEntry.value.hrVerantwortlicher[0].id;
    generateZeugnis();

    savePageData()?.then(() => {
      if(!window.location.pathname.includes('zeugnis')) {
        window.history.pushState({}, '', '/zeugnis/' + savedEntry.value.uid);
      }
      
      addAlert("Die Arbeitsbestätigung wurde erfolgreich erstellt.", "success");

      step.value = 4;
    }).catch((error) => {
      console.log(error);
      addAlert("Die Arbeitsbestätigung konnte nicht erstellt werden.", "error");
    });
  }
}

const sendBackToVorgesetzten = () => {
  if(nachrichtField.value == "") {
    addAlert("Bitte gib eine Nachricht ein.");
    return;
  }

  stepToSave.value = "ueberpruefungDurchVg1";
  createNachricht.value = true;

  zugewiesenePerson.value = savedEntry.value.vorgesetzter[0].id;

  savePageData()?.then(() => {
    sendEmailNotification(
      savedEntry.value.vorgesetzter[0].email,
      "Zeugnis zurückgewiesen - " + savedEntry.value.vorname + " " + savedEntry.value.nachname,
      `Ein Zeugnis wurde an dich zurückgewiesen. Nachricht von ${ currentUser.fullName }: ${nachrichtField.value}`
    )
    .then(() => {
      // addAlert("Das Zeugnis wurde erfolgreich gespeichert und eine Benachrichtigung an den Vorgesetzten gesendet.", "success");
      showSentOverlay("Das Zeugnis wurde erfolgreich gespeichert und eine Benachrichtigung an den Vorgesetzten gesendet.");
      
    }).catch((error) => {
      console.log(error);
      addAlert("Das Zeugnis konnte nicht an den Vorgesetzten gesendet werden.", "error");
    });
  });
}

const setAIGenerationMode = (mode: string, vorlage: any) => {
  vorlage.aiGenerationMode = mode;

  updateAItext(vorlage);
}

const setZeugnisAIGenerationMode = (mode: string) => {
  zeugnisAiMode.value = mode;

  rewriteZeugnis();
}


const setZurückAnLetztPerson = (value: boolean) => {
  zurückAnLetztePerson.value = value;
}


const sendEmailNotification = (to: string, subject: string, message: string) => {
  return axios.post('/actions/ssbl/mail/send', {
    to: to,
    subject: subject,
    message: message,
    zeugnis: window.location.href
  }).then((response) => {
    console.log(response);
  });
}

const removeBeispielCallVorlagen = (index: number) => {
  settings.value.beispielCallsVorlagen.splice(index, 1);
}

const addBeispielCallVorlagen = () => {
  settings.value.beispielCallsVorlagen.push({
    userCall: "",
    assistantAntwort: ""
  });
}

const removeBeispielCallSpellcheck = (index: number) => {
  settings.value.beispielCallsSpellcheck.splice(index, 1);
}

const addBeispielCallSpellcheck = () => {
  settings.value.beispielCallsSpellcheck.push({
    userCall: "",
    assistantAntwort: ""
  });
}

const removeBeispielCallZeugnis = (index: number) => {
  settings.value.beispielCallsZeugnis.splice(index, 1);
}

const addBeispielCallZeugnis = () => {
  settings.value.beispielCallsZeugnis.push({
    userCall: "",
    assistantAntwort: ""
  });
}

const removeBeispielCallZeugnisSpellcheck = (index: number) => {
  settings.value.beispielCallsZeugnisSpellcheck.splice(index, 1);
}

const addBeispielCallZeugnisSpellcheck = () => {
  settings.value.beispielCallsZeugnisSpellcheck.push({
    userCall: "",
    assistantAntwort: ""
  });
}


const addAlert = (message: string, type: string = 'warning') => {

  if(alerts.value.length >= 3) {
    alerts.value.shift();
  }

  alerts.value.push({
    message: message,
    type: type
  });

  setTimeout(() => {
    alerts.value.shift();
  }, 7000);
}

const showSentOverlay = (message: string) => {
  showingSentOverlay.value = true;
  sentOverlayMessage.value = message;
}

const showToolbar = (event) => {
  event.stopPropagation();
  
  editorFocused.value = true;
}

const hideToolbar = () => {
  editorFocused.value = false;
}

const toggleNav = (tab: string) => {
  if(navTab.value == tab) {
    navTab.value = null;
  }
  else {
    navTab.value = tab;
  }
}

const getZeugnisse = () => {
  axios.post(graphqlUrl, {
        query: ZeugnisseQuery,
      }, {
        headers: {
          'Authorization': "Bearer " + gqlToken
        }
      }
  ).then((response) => {
    allZeugnisse.value = response.data.data.zeugnisseEntries;
    filteredZeugnisse.value = [];

    filterZeugnisseInit();
  }).catch((error) => {
    console.log(error);
  });
}

const filterZeugnisse = () => {
  if (inactiveSince.value === 0) {
    if(showAbgeschlosseneZeugnisse.value) {
      filteredZeugnisse.value = allZeugnisse.value;
    }
    else {
      filteredZeugnisse.value = allZeugnisse.value.filter((entry: any) => {
        return entry.aktuellerSchritt != "Abgeschlossen";
      });
    }
  }
  else {
    let date = new Date();
    date.setDate(date.getDate() - inactiveSince.value);

    let tempfilteredZeugnisse = allZeugnisse.value.filter((entry: any) => {
      return new Date(entry.dateUpdated) < date;
    });

    if(showAbgeschlosseneZeugnisse.value) {
      filteredZeugnisse.value = tempfilteredZeugnisse;
    }
    else {
      filteredZeugnisse.value = tempfilteredZeugnisse.filter((entry: any) => {
        return entry.aktuellerSchritt != "Abgeschlossen";
      });
    }
  }

  if(searchQuery.value) {
    filteredZeugnisse.value = filteredZeugnisse.value.filter((entry: any) => {
      return entry.vorname.toLowerCase().includes(searchQuery.value.toLowerCase()) ||
             entry.nachname.toLowerCase().includes(searchQuery.value.toLowerCase()) ||
             entry.uid.toLowerCase().includes(searchQuery.value.toLowerCase());
    });
  }

}

const filterZeugnisseInit = () => {
  inactiveSinceOptions.value.slice().reverse().forEach((inactiveSinceOption: any) => {
    if(filteredZeugnisse.value.length == 0) {
      inactiveSince.value = inactiveSinceOption.value;
      filterZeugnisse();
    }
  })
}

const getVerantwortlichePerson = (zeugnis) => {

  if(zeugnis.nachrichten.length > 0 && zeugnis.nachrichten[zeugnis.nachrichten.length - 1].zugewiesenePerson.length > 0) {
    return zeugnis.nachrichten[zeugnis.nachrichten.length - 1].zugewiesenePerson[0];
  } else if(zeugnis.hrVerantwortlicher.length > 0) {
    return zeugnis.hrVerantwortlicher[0]
  }
  else {
    return {fullName: 'nicht zugewiesen'};
  }
}

const sendStatistikEmailNotification = (zeugnis: any) => {

  if(getVerantwortlichePerson(zeugnis).fullName === 'nicht zugewiesen') {
    return;
  }

  axios.post('/actions/ssbl/mail/send', {
    to: getVerantwortlichePerson(zeugnis).email,
    subject: "SSBL Zeugnisgenerator Erinnerung: Arbeitszeugnis noch nicht bearbeitet - " + zeugnis.vorname + " " + zeugnis.nachname,
    message: "Das Arbeitszeugnis von " + zeugnis.vorname + " " + zeugnis.nachname + " ist seit dem " + formatDate(zeugnis.dateUpdated) + " inaktiv. Bitte überprüfe den Status des Zeugnisses.",
    zeugnis: SITEURL + '/zeugnis/' + zeugnis.uid
  }).then(() => {
    addAlert("Die Erinnerung wurde gesendet.", "success");
  }).catch((error) => {
    console.log(error);
    addAlert("Die Erinnerung konnte nicht gesendet werden.", "error");
  });
}

const scrollToField = (event: Event) => {
  event.preventDefault();
  event.stopPropagation();

  const target = event.target as HTMLElement;

  if(target) {
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
}

const correctPersonalien = () => {
  savedEntry.value.aktuellerSchritt = "personalienAngeben";
}

const changeAbschlusstext = () => {
  savedEntry.value.andererAbschlussgrund = positiverAbschlusstext.value ? savedEntry.value.abschlussgrund[0].abschlusstextPositiv : savedEntry.value.abschlussgrund[0].abschlusstextNeutral;
}

const transformHTMLToBlocks = (html: string) => {
  // get Blocks <p> and <ul>
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');
  const blocks = doc.body.childNodes;
  const textBlocks: any = [];
  blocks.forEach((block: any) => {
    if(block.nodeName === 'P') {
      textBlocks.push({
        style: "text",
        blocks: transformHTMLToStyledArray(block.innerHTML)
      });
    }
    else if(block.nodeName === 'UL') {
      const listItems = block.querySelectorAll('li');
      listItems.forEach((item: any) => {
        textBlocks.push({
          style: "list",
          blocks: transformHTMLToStyledArray(item.innerHTML)
        });
      });
    }
  });

  return textBlocks;
}

const transformHTMLToStyledArray = (html: string) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');
  const result: { style: string; content: string }[] = [];

  const traverseNodes = (node: ChildNode) => {
    if (node.nodeType === Node.TEXT_NODE) {
      const textContent = node.textContent;
      if (textContent) {
        result.push({ style: "text", content: textContent });
      }
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      const element = node as HTMLElement;
      const style = element.tagName.toLowerCase();

      if (["strong", "em", "u"].includes(style)) {
        result.push({ style, content: element.textContent || "" });
      } else {
        // Recursively traverse child nodes for unsupported tags
        element.childNodes.forEach(traverseNodes);
      }
    }
  };

  doc.body.childNodes.forEach(traverseNodes);
  return result;
};

const adjustValue = () => {
  if(savedEntry.value.erstelltesZeugnis &&  savedEntry.value.erstelltesZeugnis.length > 0) {
    generateZeugnis();
  }
}

</script>

<style lang="scss" scoped>
.alerts-enter-active,
.alerts-leave-active {
  transition: all 1s ease;
}
.alerts-enter-from,
.alerts-leave-to {
  opacity: 0;
}
</style>